/**
 * Sigonna Dive runtime a11y helpers (Wokiee) � D2.2 round 2.
 * Liquid fixes preferred; this covers focus traps and app residuals.
 */
(function () {
  'use strict';

  function ensureTablists(root) {
    var scope = root || document;
    var groups = scope.querySelectorAll(
      '.featured-tabs__container__content, .featured-tabs-vertical .featured-tabs__container__content'
    );
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (!group.getAttribute('role')) {
        group.setAttribute('role', 'tablist');
      }
      var tabs = group.querySelectorAll('[role="tab"], .featured-tabs__item[role="tab"]');
      for (var j = 0; j < tabs.length; j++) {
        var tab = tabs[j];
        var selected = tab.classList.contains('active') ? 'true' : 'false';
        tab.setAttribute('aria-selected', selected);
        if (!tab.getAttribute('tabindex')) {
          tab.setAttribute('tabindex', selected === 'true' ? '0' : '-1');
        }
      }
    }
  }

  function labelAcceleratedCheckout(root) {
    var scope = root || document;
    var hosts = scope.querySelectorAll(
      'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons'
    );
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      if (!host.getAttribute('aria-label') && host.tagName && host.tagName.indexOf('SHOPIFY-ACCELERATED') === 0) {
        host.setAttribute('aria-label', 'Accelerated checkout');
      }
      var unnamed = host.querySelectorAll(
        'button:not([aria-label]):not([aria-labelledby]), a:not([aria-label]):not([aria-labelledby])'
      );
      for (var j = 0; j < unnamed.length; j++) {
        var el = unnamed[j];
        if ((el.textContent || '').trim()) continue;
        el.setAttribute('aria-label', 'Accelerated checkout option');
      }
    }
  }

  function hideOrphanRatingLegends(root) {
    var scope = root || document;
    var candidates = scope.querySelectorAll(
      '.jdgm-form__rating-legend, .jdgm-rev__rating span.jdgm-star, [class*="ryviu"] .rating-label'
    );
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^(Poor|Great)(\s+(Poor|Great))*$/i.test(text) || text === 'Poor Great') {
        el.setAttribute('aria-hidden', 'true');
      }
    }
    var badges = scope.querySelectorAll('.jdgm-preview-badge, .jdgm-widget, .ryviu-widget-total-review');
    for (var b = 0; b < badges.length; b++) {
      var spans = badges[b].querySelectorAll('span, div');
      for (var s = 0; s < spans.length; s++) {
        var t = (spans[s].textContent || '').replace(/\s+/g, ' ').trim();
        if (t === 'Poor Great' || t === 'Poor' || t === 'Great') {
          if (!spans[s].querySelector('a, button, input')) {
            spans[s].setAttribute('aria-hidden', 'true');
          }
        }
      }
    }
  }

  function syncCartAriaLabels(root) {
    var scope = root || document;
    var links = scope.querySelectorAll(
      '#cart-icon-bubble--mobile, #cart-icon-bubble--mobile-short, #cart-icon-bubble, #cart-icon-bubble-short'
    );
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var countEl = a.querySelector('.header__button__bubble__count, .cart-count-bubble [aria-hidden="true"]');
      var n = 0;
      if (countEl && /\d+/.test(countEl.textContent || '')) {
        n = parseInt((countEl.textContent || '').replace(/\D/g, ''), 10) || 0;
      } else if (window.Shopify && typeof Shopify.cartCount === 'number') {
        n = Shopify.cartCount;
      } else {
        var bubble = a.querySelector('.visually-hidden');
        var m = bubble && (bubble.textContent || '').match(/(\d+)\s+items?/i);
        if (m) n = parseInt(m[1], 10);
      }
      var countText = n === 1 ? '1 item' : n + ' items';
      a.setAttribute('aria-label', 'Cart, ' + countText);
    }
  }

  function setSearchBackgroundInert(modal, makeInert) {
    if (!modal || !document.body) return;
    var children = document.body.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el === modal || el.contains(modal) || modal.contains(el)) continue;
      if (makeInert) {
        if (!el.hasAttribute('data-dive-search-inert')) {
          el.setAttribute('data-dive-search-inert', el.inert ? '1' : '0');
        }
        try {
          el.inert = true;
        } catch (e) {
          el.setAttribute('inert', '');
        }
      } else if (el.hasAttribute('data-dive-search-inert')) {
        var prev = el.getAttribute('data-dive-search-inert');
        el.removeAttribute('data-dive-search-inert');
        try {
          el.inert = prev === '1';
        } catch (e2) {
          if (prev === '1') el.setAttribute('inert', '');
          else el.removeAttribute('inert');
        }
        if (prev !== '1') el.removeAttribute('inert');
      }
    }
  }

  function focusSearchField(modal) {
    if (!modal) return;
    var dialog = modal.querySelector('[role="dialog"]');
    var input = modal.querySelector('#Search-In-Modal, input[type="search"]');
    var closeBtn = modal.querySelector('.popup-modal__toggle');
    if (dialog) {
      dialog.setAttribute('aria-label', dialog.getAttribute('aria-label') || 'Search');
      if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    }
    var focusTarget = input || closeBtn || dialog;
    if (!focusTarget) return;
    if (typeof trapFocus === 'function') {
      trapFocus(modal, focusTarget);
    }
    try {
      focusTarget.focus({ preventScroll: true });
    } catch (e) {
      try {
        focusTarget.focus();
      } catch (e2) {}
    }
  }

  function patchMenuDrawer() {
    var Ctor = customElements.get('menu-drawer');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__diveA11yPatched) return;
    var proto = Ctor.prototype;
    proto.__diveA11yPatched = true;

    var origOpen = proto.openMenuDrawer;
    proto.openMenuDrawer = function (summaryElement) {
      origOpen.call(this, summaryElement);
      var summary =
        summaryElement ||
        (this.mainDetailsToggle && this.mainDetailsToggle.querySelector('summary'));
      var dialog = this.querySelector('[role="dialog"]');
      var closeBtn = this.querySelector('.popup-modal__toggle');
      if (summary) summary.setAttribute('aria-expanded', 'true');
      if (dialog && !dialog.getAttribute('aria-label')) {
        dialog.setAttribute('aria-label', 'Menu');
      }
      var focusTarget = closeBtn || dialog;
      if (typeof trapFocus === 'function' && this.mainDetailsToggle && focusTarget) {
        trapFocus(this.mainDetailsToggle, focusTarget);
      } else if (focusTarget && focusTarget.focus) {
        try {
          focusTarget.focus();
        } catch (e) {}
      }
    };

    var origClose = proto.closeMenuDrawer;
    proto.closeMenuDrawer = function (event, elementToFocus) {
      var summary =
        this.mainDetailsToggle && this.mainDetailsToggle.querySelector('summary');
      if (event === undefined || event === 'custom') {
        event = { type: 'close' };
      }
      origClose.call(this, event, summary || elementToFocus);
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(summary);
        } else {
          try {
            summary.focus();
          } catch (e2) {}
        }
      }
    };
  }

  function patchSearchModal() {
    var Ctor = customElements.get('modal-dialog');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__diveA11ySearchPatched) return;
    var proto = Ctor.prototype;
    proto.__diveA11ySearchPatched = true;

    var origShow = proto.show;
    proto.show = function (opener) {
      origShow.call(this, opener);
      if (this.id !== 'header-modal-search') return;
      var self = this;
      setSearchBackgroundInert(self, true);
      var activate = function () {
        if (!self.classList.contains('active') && !self.classList.contains('animate')) return;
        focusSearchField(self);
      };
      requestAnimationFrame(function () {
        setTimeout(activate, 0);
        setTimeout(activate, 60);
        setTimeout(activate, 250);
      });
    };

    var origClose = proto.close;
    proto.close = function () {
      if (this.id === 'header-modal-search') {
        setSearchBackgroundInert(this, false);
      }
      origClose.call(this);
    };
  }

  function bindSearchEscape() {
    if (document.documentElement.__diveSearchEscapeBound) return;
    document.documentElement.__diveSearchEscapeBound = true;
    document.addEventListener(
      'keydown',
      function (event) {
        var key = event.key || event.code || '';
        if (key !== 'Escape' && key !== 'Esc' && event.code !== 'Escape') return;
        var modal = document.getElementById('header-modal-search');
        if (!modal) return;
        if (!modal.classList.contains('active') && !modal.classList.contains('animate')) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof modal.close === 'function') modal.close();
      },
      true
    );
  }

  /* SD-R15-NVDA-002: Escape closes the responsive navigation from any
     descendant, including an open nested GEAR panel, and returns to Menu. */
  function bindMenuDrawerEscape() {
    if (document.documentElement.__diveR15MenuDrawerEscapeBound) return;
    document.documentElement.__diveR15MenuDrawerEscapeBound = true;
    document.addEventListener(
      'keydown',
      function (event) {
        var key = event.key || event.code || '';
        if (key !== 'Escape' && key !== 'Esc' && event.code !== 'Escape') return;
        var target = event.target;
        var drawer = target && target.closest ? target.closest('menu-drawer') : null;
        if (!drawer) {
          var candidates = document.querySelectorAll('menu-drawer');
          for (var i = candidates.length - 1; i >= 0; i--) {
            var mainDetails = candidates[i].mainDetailsToggle ||
              candidates[i].querySelector(':scope > details');
            if (mainDetails && mainDetails.open) {
              drawer = candidates[i];
              break;
            }
          }
        }
        if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;
        var details = drawer.mainDetailsToggle || drawer.querySelector(':scope > details');
        if (!details || !details.open) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        drawer.closeMenuDrawer(event);
      },
      true
    );
  }

  function whenDefined(name, fn) {
    if (customElements.get(name)) {
      fn();
      return;
    }
    if (customElements.whenDefined) {
      customElements.whenDefined(name).then(fn);
    } else {
      setTimeout(fn, 500);
    }
  }

  function run(root) {
    ensureTablists(root || document);
    labelAcceleratedCheckout(root || document);
    hideOrphanRatingLegends(root || document);
    syncCartAriaLabels(root || document);
  }

  whenDefined('menu-drawer', patchMenuDrawer);
  whenDefined('modal-dialog', patchSearchModal);
  bindSearchEscape();
  bindMenuDrawerEscape();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document);
      whenDefined('menu-drawer', patchMenuDrawer);
      whenDefined('modal-dialog', patchSearchModal);
      bindSearchEscape();
      bindMenuDrawerEscape();
    });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    run((e && e.target) || document);
  });

  document.addEventListener('cart:updated', function () {
    run(document);
  });

  // Cart drawer section re-renders replace bubble markup; re-apply Cart purpose.
  var mo = new MutationObserver(function () {
    syncCartAriaLabels(document);
  });
  if (document.body) {
    mo.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }
})();

/* SIGONNA-DIVE-ADA-R8-20260810 */
(function () {
  'use strict';
  if (window.__sigonnaDiveR8FacetLinkHardeningLoaded) return;
  window.__sigonnaDiveR8FacetLinkHardeningLoaded = true;

  var repairPending = false;

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function copyAttributes(source, target) {
    for (var i = 0; i < source.attributes.length; i++) {
      var attribute = source.attributes[i];
      target.setAttribute(attribute.name, attribute.value);
    }
  }

  function repairDesktopAvailabilityGroups() {
    var displays = document.querySelectorAll(
      'div.facets__display__content:not([data-dive-r8-desktop-facet-fieldset])'
    );
    for (var i = 0; i < displays.length; i++) {
      var inputs = displays[i].querySelectorAll('input[type="checkbox"],input[type="radio"]');
      if (inputs.length < 2) continue;
      var inputName = inputs[0].getAttribute('name') || '';
      if (!/availability/i.test(inputName)) continue;
      var sameGroup = true;
      for (var n = 1; n < inputs.length; n++) {
        if ((inputs[n].getAttribute('name') || '') !== inputName) sameGroup = false;
      }
      if (!sameGroup) continue;

      var fieldset = document.createElement('fieldset');
      copyAttributes(displays[i], fieldset);
      fieldset.setAttribute('data-dive-r7-facet-fieldset', 'true');
      fieldset.setAttribute('data-dive-r8-desktop-facet-fieldset', 'true');
      var legend = document.createElement('legend');
      legend.setAttribute('data-dive-r7-facet-legend', 'true');
      legend.setAttribute('data-dive-r8-desktop-facet-legend', 'true');
      legend.textContent = 'Availability';
      fieldset.appendChild(legend);
      while (displays[i].firstChild) fieldset.appendChild(displays[i].firstChild);
      displays[i].parentNode.replaceChild(fieldset, displays[i]);
    }
  }

  function repairPrivacyOptOutLinkNames() {
    var links = document.querySelectorAll(
      'a[href*="/pages/data-sharing-opt-out"]:not([data-dive-r8-policy-link-name])'
    );
    for (var i = 0; i < links.length; i++) {
      if (cleanText(links[i].textContent).toLowerCase() !== 'here') continue;
      links[i].setAttribute(
        'aria-label',
        'Opt out of sale, sharing, or targeted advertising'
      );
      links[i].setAttribute('data-dive-r8-policy-link-name', 'true');
    }
  }

  function repair() {
    repairPending = false;
    repairDesktopAvailabilityGroups();
    repairPrivacyOptOutLinkNames();
  }

  function scheduleRepair() {
    if (repairPending) return;
    repairPending = true;
    window.requestAnimationFrame(repair);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repair, { once: true });
  } else {
    repair();
  }
  window.setTimeout(repair, 400);
  window.setTimeout(repair, 1400);
  window.setTimeout(repair, 3700);
  new MutationObserver(scheduleRepair).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* SIGONNA-DIVE-ADA-R7-20260810 */
/**
 * Remediate the confirmed hosted-WAVE root causes without changing visible
 * content or interaction. This layer intentionally leaves advisory redundant
 * link, event-handler, small-text, and NOSCRIPT alerts unchanged.
 */
(function () {
  'use strict';

  if (window.__sigonnaDiveR7WaveHardeningLoaded) return;
  window.__sigonnaDiveR7WaveHardeningLoaded = true;

  var repairPending = false;
  var auxiliaryModalState = Object.create(null);

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function replaceTag(element, tagName, configure) {
    if (!element || !element.parentNode) return null;
    var replacement = document.createElement(tagName);
    for (var i = 0; i < element.attributes.length; i++) {
      var attribute = element.attributes[i];
      replacement.setAttribute(attribute.name, attribute.value);
    }
    while (element.firstChild) replacement.appendChild(element.firstChild);
    if (configure) configure(replacement, element);
    element.parentNode.replaceChild(replacement, element);
    return replacement;
  }

  function repairHeadingMarkup() {
    var quickViewHeadings = document.querySelectorAll('h4');
    for (var q = 0; q < quickViewHeadings.length; q++) {
      if (!/^Have a question\?/i.test(cleanText(quickViewHeadings[q].textContent))) continue;
      quickViewHeadings[q].setAttribute('role', 'heading');
      quickViewHeadings[q].setAttribute('aria-level', '2');
      quickViewHeadings[q].setAttribute('data-dive-r7-quickview-heading', 'true');
    }

    var reviewTitles = document.querySelectorAll('p.jm-review-content__title');
    for (var r = 0; r < reviewTitles.length; r++) {
      replaceTag(reviewTitles[r], 'div', function (replacement) {
        replacement.setAttribute('role', 'heading');
        replacement.setAttribute('aria-level', '3');
        replacement.setAttribute('data-dive-r7-review-heading', 'true');
      });
    }

    var cartTitles = document.querySelectorAll('.cart-page__heading > p.h2');
    for (var c = 0; c < cartTitles.length; c++) {
      cartTitles[c].setAttribute('role', 'heading');
      cartTitles[c].setAttribute('aria-level', '1');
      cartTitles[c].setAttribute('data-dive-r7-cart-heading', 'true');
    }
  }

  function facetName(details, inputs) {
    var summary = details && details.querySelector(':scope > summary');
    var name = summary ? cleanText(summary.textContent) : '';
    if (name) return name.replace(/\s*\(\d+\)\s*$/, '');
    var inputName = inputs.length ? inputs[0].getAttribute('name') || '' : '';
    if (/availability/i.test(inputName)) return 'Availability';
    return 'Filter options';
  }

  function repairFacetFieldsets() {
    var displays = document.querySelectorAll(
      'div.mobile-facets__display__content:not([data-dive-r7-facet-fieldset])'
    );
    for (var i = 0; i < displays.length; i++) {
      var inputs = displays[i].querySelectorAll('input[type="checkbox"],input[type="radio"]');
      if (inputs.length < 2) continue;
      var names = Object.create(null);
      for (var n = 0; n < inputs.length; n++) {
        var name = inputs[n].getAttribute('name') || '';
        if (name) names[name] = (names[name] || 0) + 1;
      }
      var grouped = false;
      for (var key in names) {
        if (Object.prototype.hasOwnProperty.call(names, key) && names[key] > 1) grouped = true;
      }
      if (!grouped) continue;

      var details = displays[i].closest('details');
      var label = facetName(details, inputs);
      replaceTag(displays[i], 'fieldset', function (replacement) {
        replacement.setAttribute('data-dive-r7-facet-fieldset', 'true');
        var legend = document.createElement('legend');
        legend.setAttribute('data-dive-r7-facet-legend', 'true');
        legend.textContent = label;
        replacement.insertBefore(legend, replacement.firstChild);
      });
    }
  }

  function mediaSource(image) {
    return (image.currentSrc || image.getAttribute('src') || '').split('?')[0];
  }

  function repairProductMediaAlternatives() {
    var mainImages = Array.prototype.slice.call(
      document.querySelectorAll('.product-media__item img[alt]')
    );
    if (mainImages.length < 2) return;

    var groups = Object.create(null);
    for (var i = 0; i < mainImages.length; i++) {
      var original = mainImages[i].getAttribute('data-dive-r7-original-alt');
      if (original === null) original = cleanText(mainImages[i].getAttribute('alt'));
      if (!original) continue;
      if (!groups[original]) groups[original] = [];
      groups[original].push(mainImages[i]);
    }

    var duplicatedOriginals = Object.create(null);
    for (var originalText in groups) {
      if (!Object.prototype.hasOwnProperty.call(groups, originalText)) continue;
      var uniqueSources = Object.create(null);
      for (var g = 0; g < groups[originalText].length; g++) {
        uniqueSources[mediaSource(groups[originalText][g])] = true;
      }
      if (Object.keys(uniqueSources).length < 2) continue;
      duplicatedOriginals[originalText] = true;
      for (var m = 0; m < groups[originalText].length; m++) {
        var image = groups[originalText][m];
        var position = mainImages.indexOf(image) + 1;
        image.setAttribute('data-dive-r7-original-alt', originalText);
        image.setAttribute('alt', originalText + ' — product view ' + position + ' of ' + mainImages.length);
        image.setAttribute('data-dive-r7-unique-media-alt', 'true');
      }
    }

    var thumbnails = document.querySelectorAll('.product__media__thumb img[alt]');
    for (var t = 0; t < thumbnails.length; t++) {
      var thumbnailAlt = thumbnails[t].getAttribute('data-dive-r7-original-alt');
      if (thumbnailAlt === null) thumbnailAlt = cleanText(thumbnails[t].getAttribute('alt'));
      if (!thumbnailAlt || !duplicatedOriginals[thumbnailAlt]) continue;
      thumbnails[t].setAttribute('data-dive-r7-original-alt', thumbnailAlt);
      thumbnails[t].setAttribute('alt', '');
      thumbnails[t].setAttribute('data-dive-r7-decorative-thumbnail', 'true');
    }
  }

  function auxiliaryModalIsOpen(modal) {
    if (!modal) return false;
    var style = window.getComputedStyle(modal);
    var rect = modal.getBoundingClientRect();
    return (
      modal.classList.contains('active') || modal.classList.contains('animate') ||
      (rect.width > 0 && rect.height > 0 && style.display !== 'none' &&
        style.visibility !== 'hidden' && Number.parseFloat(style.opacity || '1') > 0)
    );
  }

  function auxiliaryModalOpener(modal) {
    var state = auxiliaryModalState[modal.id] || (auxiliaryModalState[modal.id] = {});
    if (state.opener && document.contains(state.opener)) return state.opener;
    state.opener = document.querySelector(
      'modal-opener[data-modal="#' + modal.id + '"] button, ' +
      'modal-opener[data-modal="#' + modal.id + '"] [role="button"]'
    );
    return state.opener;
  }

  function restoreAuxiliaryModalFocus(modal) {
    var opener = auxiliaryModalOpener(modal);
    if (typeof window.removeTrapFocus === 'function') {
      try {
        window.removeTrapFocus(opener || undefined);
      } catch (error) {}
    }
    if (!opener || typeof opener.focus !== 'function') return;
    window.setTimeout(function () {
      try {
        opener.focus({ preventScroll: true });
      } catch (error) {
        try {
          opener.focus();
        } catch (focusError) {}
      }
    }, 0);
  }

  function repairAuxiliaryModals() {
    var modals = document.querySelectorAll('#PopupModal-message,#PopupModal-quickview');
    for (var i = 0; i < modals.length; i++) {
      var modal = modals[i];
      var state = auxiliaryModalState[modal.id] || (auxiliaryModalState[modal.id] = {});
      var dialog = modal.querySelector('[role="dialog"]');
      var heading = dialog && dialog.querySelector(
        '[data-dive-r7-quickview-heading],[role="heading"],h1,h2,h3,h4,h5,h6'
      );
      if (dialog && heading && !dialog.getAttribute('aria-label') && !dialog.getAttribute('aria-labelledby')) {
        if (!heading.id) heading.id = modal.id + '-heading';
        dialog.setAttribute('aria-labelledby', heading.id);
        dialog.setAttribute('data-dive-r7-dialog-name', 'heading');
      }

      var open = auxiliaryModalIsOpen(modal);
      if (open && !state.wasOpen) {
        state.wasOpen = true;
        var closeButton = modal.querySelector('.popup-modal__toggle');
        auxiliaryModalOpener(modal);
        if (typeof window.trapFocus === 'function' && closeButton) {
          try {
            window.trapFocus(modal, closeButton);
          } catch (error) {}
        }
        if (closeButton) {
          window.setTimeout(function (button) {
            try {
              button.focus({ preventScroll: true });
            } catch (error) {
              try {
                button.focus();
              } catch (focusError) {}
            }
          }, 0, closeButton);
        }
      } else if (!open && state.wasOpen) {
        state.wasOpen = false;
        restoreAuxiliaryModalFocus(modal);
      }
    }
  }

  function repair() {
    repairPending = false;
    repairHeadingMarkup();
    repairFacetFieldsets();
    repairProductMediaAlternatives();
    repairAuxiliaryModals();
  }

  function scheduleRepair() {
    if (repairPending) return;
    repairPending = true;
    window.requestAnimationFrame(repair);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target && event.target.closest ? event.target.closest('button,[role="button"]') : null;
      if (!target) return;
      var opener = target.closest('modal-opener[data-modal="#PopupModal-message"],modal-opener[data-modal="#PopupModal-quickview"]');
      if (opener) {
        var modalSelector = opener.getAttribute('data-modal') || '';
        var modalId = modalSelector.replace(/^#/, '');
        if (modalId) {
          var state = auxiliaryModalState[modalId] || (auxiliaryModalState[modalId] = {});
          state.opener = target;
        }
      }

      var modal = target.closest('#PopupModal-message,#PopupModal-quickview');
      if (modal && target.matches('.popup-modal__toggle,[aria-label*="Close" i]')) {
        window.setTimeout(function () {
          restoreAuxiliaryModalFocus(modal);
        }, 0);
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      var key = event.key || event.code || '';
      if (key !== 'Escape' && key !== 'Esc' && event.code !== 'Escape') return;
      var candidates = document.querySelectorAll('#PopupModal-message,#PopupModal-quickview');
      for (var i = candidates.length - 1; i >= 0; i--) {
        var modal = candidates[i];
        if (!auxiliaryModalIsOpen(modal)) continue;
        event.preventDefault();
        event.stopPropagation();
        if (typeof modal.close === 'function') modal.close();
        else {
          modal.classList.remove('active');
          modal.classList.remove('animate');
        }
        var state = auxiliaryModalState[modal.id] || (auxiliaryModalState[modal.id] = {});
        state.wasOpen = false;
        restoreAuxiliaryModalFocus(modal);
        break;
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repair, { once: true });
  } else {
    repair();
  }
  window.setTimeout(repair, 400);
  window.setTimeout(repair, 1400);
  window.setTimeout(repair, 3700);
  new MutationObserver(scheduleRepair).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/**
 * Sigonna Dive R1 accessibility remediation closure (2026-08-05).
 * Appended after the existing D2.2 helpers. Keep selectors limited to
 * confirmed SD-R1-001..010 patterns.
 */
(function () {
  'use strict';

  if (window.__sigonnaDiveR1RemediationLoaded) return;
  window.__sigonnaDiveR1RemediationLoaded = true;

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function uniqueId(base) {
    var index = 2;
    var candidate = base + '--a11y-' + index;
    while (document.getElementById(candidate)) {
      index += 1;
      candidate = base + '--a11y-' + index;
    }
    return candidate;
  }

  function dedupeKnownIds() {
    var elements = document.querySelectorAll('[id]');
    var seen = Object.create(null);
    var generatedFormIndex = 0;

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      // HTMLFormElement named properties can shadow `.id` when a form contains
      // an input named `id`. Read and write the actual attribute explicitly.
      var id = element.getAttribute('id') || '';
      if (!id) continue;

      if (/^\[object\s/i.test(id)) {
        generatedFormIndex += 1;
        var formId = 'a11y-product-form-' + generatedFormIndex;
        while (document.getElementById(formId)) {
          generatedFormIndex += 1;
          formId = 'a11y-product-form-' + generatedFormIndex;
        }
        element.setAttribute('data-a11y-original-id', id);
        element.setAttribute('id', formId);
        continue;
      }

      if (!seen[id]) {
        seen[id] = element;
        continue;
      }

      element.setAttribute('data-a11y-original-id', id);
      element.setAttribute('id', uniqueId(id));
    }
  }

  function repairLoaders() {
    var loaders = document.querySelectorAll(
      '.themeloader_container[aria-labelledby="loader"], ' +
      '.themeloader_container[data-a11y-original-aria-labelledby="loader"]'
    );
    for (var i = 0; i < loaders.length; i++) {
      loaders[i].removeAttribute('aria-labelledby');
      loaders[i].removeAttribute('data-a11y-original-aria-labelledby');
      loaders[i].setAttribute('role', 'status');
      loaders[i].setAttribute('aria-label', 'Loading');
      loaders[i].setAttribute('aria-live', 'polite');
      loaders[i].setAttribute('aria-atomic', 'true');
    }
  }

  function repairAriaReferences() {
    var attributes = ['aria-controls', 'aria-owns', 'aria-labelledby'];

    for (var a = 0; a < attributes.length; a++) {
      var attribute = attributes[a];
      var dataAttribute = 'data-a11y-original-' + attribute;
      var selector = '[' + attribute + '],[' + dataAttribute + ']';
      var elements = document.querySelectorAll(selector);

      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var current = element.getAttribute(attribute) || '';
        var original = element.getAttribute(dataAttribute) || '';
        var desired = original || current;
        if (!desired) continue;

        var ids = desired.split(/\s+/).filter(Boolean);
        var valid = [];
        for (var j = 0; j < ids.length; j++) {
          if (document.getElementById(ids[j])) valid.push(ids[j]);
        }

        if (valid.length === ids.length) {
          element.setAttribute(attribute, desired);
          element.removeAttribute(dataAttribute);
        } else {
          if (!original) element.setAttribute(dataAttribute, desired);
          if (valid.length) element.setAttribute(attribute, valid.join(' '));
          else element.removeAttribute(attribute);
        }
      }
    }
  }

  function repairRolesAndLabels() {
    var statuses = document.querySelectorAll('h4[role="status"]');
    for (var i = 0; i < statuses.length; i++) {
      statuses[i].removeAttribute('role');
      statuses[i].setAttribute('aria-live', 'polite');
      statuses[i].setAttribute('aria-atomic', 'true');
    }

    var breadcrumbs = document.querySelectorAll('.breadcrumb[aria-label]');
    for (var b = 0; b < breadcrumbs.length; b++) {
      breadcrumbs[b].setAttribute('role', 'navigation');
    }

    var currentPages = document.querySelectorAll(
      'span.pagination__item--current[aria-current="page"][aria-label]'
    );
    for (var p = 0; p < currentPages.length; p++) {
      currentPages[p].removeAttribute('aria-label');
    }
  }

  function exposeHeadingLevel(element, level) {
    if (!element) return;
    if (
      element.matches &&
      element.matches('.blog-posts__heading') &&
      element.querySelector('h1,h2,h3,h4,h5,h6,[role="heading"]')
    ) {
      element.removeAttribute('role');
      element.removeAttribute('aria-level');
      element.removeAttribute('data-a11y-heading-level');
      element.setAttribute('data-dive-r15-native-heading-container', 'true');
      return;
    }
    var normalizedChild = element.querySelector(
      ':scope > [data-dive-r2-heading-text][role="heading"][aria-level="2"]'
    );
    if (normalizedChild) {
      element.setAttribute('role', 'presentation');
      element.removeAttribute('aria-level');
      element.setAttribute('data-dive-r9-stable-heading-wrapper', 'true');
      return;
    }
    element.setAttribute('role', 'heading');
    element.setAttribute('aria-level', String(level));
    element.setAttribute('data-a11y-heading-level', String(level));
  }

  function repairHeadingOrder() {
    var selectors = [
      '.product-tab__heading__text > h6',
      '.blog-posts__heading',
      '.facet-drawer__toolbar > h4',
      'main h4[aria-live="polite"][aria-atomic="true"]',
      '.totals__subtotal',
      '.drawer__heading',
      'toggle-component .chm-toggle__button > h6',
      '.shopify-policy__body h3'
    ];
    var headings = document.querySelectorAll(selectors.join(','));
    for (var i = 0; i < headings.length; i++) exposeHeadingLevel(headings[i], 2);
  }

  function hideDuplicateTransitionText() {
    var groups = document.querySelectorAll('.btn__texts');
    for (var i = 0; i < groups.length; i++) {
      var top = groups[i].querySelector('.btn__top-text');
      var bottom = groups[i].querySelector('.btn__bottom-text');
      if (!top || !bottom) continue;

      if (cleanText(top.textContent) && cleanText(top.textContent) === cleanText(bottom.textContent)) {
        bottom.setAttribute('aria-hidden', 'true');
        bottom.setAttribute('data-a11y-duplicate-text-hidden', 'true');
      } else if (bottom.getAttribute('data-a11y-duplicate-text-hidden') === 'true') {
        bottom.removeAttribute('aria-hidden');
        bottom.removeAttribute('data-a11y-duplicate-text-hidden');
      }
    }
  }

  function labelBrandLinks() {
    var brandNames = {
      '/collections/atomic-aquatics': 'Atomic Aquatics',
      '/collections/bare': 'Bare',
      '/collections/hollis': 'Hollis',
      '/collections/ocean-reef': 'Ocean Reef',
      '/collections/oceanic': 'Oceanic',
      '/collections/seac': 'Seac',
      '/collections/stahlsac': 'Stahlsac',
      '/collections/tusa': 'TUSA'
    };
    var links = document.querySelectorAll('a.brand-grid[aria-label="brands"]');
    for (var i = 0; i < links.length; i++) {
      var path = (links[i].getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      if (brandNames[path]) links[i].setAttribute('aria-label', brandNames[path]);
    }
  }

  function repairLinkPurpose() {
    var links = document.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var text = cleanText(link.textContent);
      var href = link.getAttribute('href') || '';

      if (href === '/' && /^Terms and Conditions\.?$/i.test(text)) {
        link.setAttribute('href', '/policies/terms-of-service');
      }

      if (text.toLowerCase() === 'support@sigonnadive.com' && href === '/pages/contacts') {
        link.setAttribute('href', 'mailto:support@sigonnadive.com');
        link.setAttribute('title', 'Email support@sigonnadive.com');
      }
    }
  }

  function exposeListItems() {
    var items = document.querySelectorAll(
      '.section__richtext__editor ul > li, .section__richtext__editor ol > li'
    );
    for (var i = 0; i < items.length; i++) {
      items[i].setAttribute('role', 'listitem');

      // Shopify rich text wraps each list-item label in a paragraph. Chromium
      // otherwise exposes that paragraph as the direct child of the list in
      // flattened snapshots. Present the wrapper only; keep its text on the
      // native/explicit listitem container.
      if (items[i].children.length === 1 && items[i].children[0].tagName === 'P') {
        items[i].children[0].setAttribute('role', 'presentation');
        items[i].children[0].setAttribute('data-a11y-listitem-paragraph', 'true');
      }
    }
  }

  function runR1Repairs() {
    dedupeKnownIds();
    repairLoaders();
    repairAriaReferences();
    repairRolesAndLabels();
    repairHeadingOrder();
    hideDuplicateTransitionText();
    labelBrandLinks();
    repairLinkPurpose();
    exposeListItems();
  }

  var scheduled = false;
  function scheduleR1Repairs() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      runR1Repairs();
    }, 40);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runR1Repairs);
  } else {
    runR1Repairs();
  }

  document.addEventListener('shopify:section:load', scheduleR1Repairs);
  document.addEventListener('cart:updated', scheduleR1Repairs);

  if (document.body) {
    new MutationObserver(scheduleR1Repairs).observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      new MutationObserver(scheduleR1Repairs).observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
})();


/**
 * SigonnaDive R2 accessibility remediation (2026-08-05).
 *
 * This runtime layer is intentionally limited to the confirmed R2 failures:
 * mobile Filter and sort modal semantics, dormant Judge.me review markup,
 * full-cart AJAX focus/status, native H6 heading levels, and mini-cart focus
 * and modal isolation.
 */
(function () {
  'use strict';

  if (window.__sigonnaDiveR2RemediationLoaded) return;
  window.__sigonnaDiveR2RemediationLoaded = true;

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
    'select:not([disabled]), textarea:not([disabled]), iframe, ' +
    '[tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

  var filterWasOpen = false;
  var cartDrawerWasOpen = false;
  var cartDrawerOpener = null;
  var cartDrawerFocusTimers = [];
  var cartQuantityPending = null;
  var cartQuantityTimers = [];
  var scheduled = false;

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function focusElement(element) {
    if (!element || typeof element.focus !== 'function') return false;
    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      try {
        element.focus();
      } catch (fallbackError) {
        return false;
      }
    }
    return document.activeElement === element;
  }

  function isVisible(element) {
    if (!element || element.disabled || element.inert) return false;
    if (element.getAttribute('aria-hidden') === 'true') return false;
    if (element.closest && element.closest('[aria-hidden="true"], [inert]')) return false;
    if (typeof element.getClientRects === 'function' && !element.getClientRects().length) {
      return false;
    }
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function focusables(container) {
    if (!container) return [];
    var nodes = container.querySelectorAll(FOCUSABLE);
    var result = [];
    for (var i = 0; i < nodes.length; i++) {
      if (isVisible(nodes[i])) result.push(nodes[i]);
    }
    return result;
  }

  function setElementInert(element, marker, makeInert) {
    if (!element || element.nodeType !== 1) return;
    if (makeInert) {
      if (!element.hasAttribute(marker)) {
        element.setAttribute(marker, element.inert ? '1' : '0');
      }
      try {
        element.inert = true;
      } catch (error) {
        element.setAttribute('inert', '');
      }
      return;
    }

    if (!element.hasAttribute(marker)) return;
    var wasInert = element.getAttribute(marker) === '1';
    element.removeAttribute(marker);
    try {
      element.inert = wasInert;
    } catch (restoreError) {
      if (wasInert) element.setAttribute('inert', '');
      else element.removeAttribute('inert');
    }
    if (!wasInert) element.removeAttribute('inert');
  }

  /*
   * Isolate a nested popup without hiding its own Close button. Starting at
   * the .popup-modal root, every sibling branch up to body is made inert and
   * later restored to its exact previous state.
   */
  function setPopupBackgroundInert(popup, marker, makeInert) {
    if (!document.body) return;
    if (!makeInert) {
      var parked = document.querySelectorAll('[' + marker + ']');
      for (var p = 0; p < parked.length; p++) setElementInert(parked[p], marker, false);
      return;
    }
    if (!popup) return;

    var branch = popup;
    while (branch && branch !== document.body) {
      var parent = branch.parentElement;
      if (!parent) break;
      var children = parent.children;
      for (var i = 0; i < children.length; i++) {
        if (children[i] !== branch) setElementInert(children[i], marker, true);
      }
      branch = parent;
    }
  }

  function trapActivePopupTab(event) {
    if (event.key !== 'Tab') return;
    var popup = null;
    var filterDetails = document.getElementById('mobile-facets');
    var cartDrawer = document.querySelector('cart-drawer.cart-drawer-container');

    if (filterDetails && filterDetails.open) {
      popup = filterDetails.querySelector('.popup-modal');
    } else if (
      cartDrawer &&
      (cartDrawer.classList.contains('active') || cartDrawer.classList.contains('animate'))
    ) {
      popup = cartDrawer;
    }
    if (!popup) return;

    var nodes = focusables(popup);
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = document.activeElement;
    if (!popup.contains(active)) {
      event.preventDefault();
      focusElement(event.shiftKey ? last : first);
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      focusElement(last);
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      focusElement(first);
    }
  }

  /* SD-R2-001: correct the facet dialog identity and isolate the modal. */
  function syncFilterDialog() {
    var details = document.getElementById('mobile-facets');
    var form = document.getElementById('FacetFiltersFormMobile');
    var dialog = form && form.closest('[role="dialog"]');
    var popup = dialog && dialog.closest('.popup-modal');
    var open = !!(details && details.open && dialog && popup);

    if (dialog) {
      dialog.setAttribute('aria-label', 'Filter and sort');
      dialog.setAttribute('aria-modal', 'true');
      if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    }

    if (open) {
      setPopupBackgroundInert(popup, 'data-dive-r2-filter-inert', true);
      if (!filterWasOpen) {
        filterWasOpen = true;
        var closeButton = popup.querySelector('.popup-modal__toggle');
        if (typeof window.trapFocus === 'function' && closeButton) {
          window.trapFocus(popup, closeButton);
        }
        if (closeButton) setTimeout(function () { focusElement(closeButton); }, 0);
      }
    } else {
      setPopupBackgroundInert(null, 'data-dive-r2-filter-inert', false);
      filterWasOpen = false;
    }
  }

  /*
   * SD-R2-002/008: Judge.me leaves display:none review dialogs exposed through
   * generated ::before/::after Poor/Great content. Hide only dormant dialogs;
   * restore them when opened, and correct each star's programmatic value.
   */
  function syncJudgeReviewModals() {
    var modals = document.querySelectorAll('.jdgm-review-widget-modal.jdgm-write-review-modal');
    for (var i = 0; i < modals.length; i++) {
      var modal = modals[i];
      var hidden = window.getComputedStyle(modal).display === 'none';
      if (hidden) {
        if (!modal.hasAttribute('data-dive-r2-judge-hidden')) {
          modal.setAttribute(
            'data-dive-r2-judge-hidden',
            modal.hasAttribute('aria-hidden') ? modal.getAttribute('aria-hidden') : '__missing__'
          );
        }
        modal.setAttribute('aria-hidden', 'true');
        try {
          modal.inert = true;
        } catch (error) {
          modal.setAttribute('inert', '');
        }
      } else if (modal.hasAttribute('data-dive-r2-judge-hidden')) {
        var prior = modal.getAttribute('data-dive-r2-judge-hidden');
        modal.removeAttribute('data-dive-r2-judge-hidden');
        if (prior === '__missing__') modal.removeAttribute('aria-hidden');
        else modal.setAttribute('aria-hidden', prior);
        try {
          modal.inert = false;
        } catch (restoreError) {}
        modal.removeAttribute('inert');
      }

      var stars = modal.querySelectorAll('.jdgm-write-review-modal__stars [data-alt]');
      for (var s = 0; s < stars.length; s++) {
        var value = parseInt(stars[s].getAttribute('data-alt'), 10);
        if (!value || value < 1 || value > 5) continue;
        var label = value + (value === 1 ? ' star' : ' stars');
        stars[s].setAttribute('aria-label', label);
        stars[s].setAttribute('title', label);
      }
    }
  }

  /*
   * SD-R2-004/009: Chromium keeps a native H6/H4 level even when aria-level=2
   * is placed on the native heading. Preserve the styled element as a
   * presentation wrapper and expose its text through one real ARIA level-2
   * child heading.
   */
  function normalizeCollapsibleHeadings() {
    var headings = document.querySelectorAll(
      '.product-tab__heading__text > h6, toggle-component .chm-toggle__button > h6, ' +
        '.cart-page__message-heading, .cart-page__message-discount, ' +
        '.facet-drawer__toolbar > h4, .drawer__heading'
    );
    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      var semantic = heading.querySelector(':scope > [data-dive-r2-heading-text]');
      if (!semantic) {
        semantic = document.createElement('span');
        semantic.setAttribute('data-dive-r2-heading-text', 'true');
        while (heading.firstChild) semantic.appendChild(heading.firstChild);
        heading.appendChild(semantic);
      }
      heading.setAttribute('role', 'presentation');
      heading.removeAttribute('aria-level');
      semantic.setAttribute('role', 'heading');
      semantic.setAttribute('aria-level', '2');
    }
  }

  function cartDrawerIsOpen(drawer) {
    return !!(
      drawer &&
      (drawer.classList.contains('active') || drawer.classList.contains('animate'))
    );
  }

  /* SD-R15-NVDA-006: use the drawer's verified Close path for Escape. */
  function closeCartDrawerOnEscape(event) {
    var key = event.key || event.code || '';
    if (key !== 'Escape' && key !== 'Esc' && event.code !== 'Escape') return false;
    var drawer = document.querySelector('cart-drawer.cart-drawer-container');
    if (!cartDrawerIsOpen(drawer)) return false;
    var target = event.target;
    var active = document.activeElement;
    if (
      target &&
      target !== document.body &&
      !drawer.contains(target) &&
      active &&
      !drawer.contains(active)
    ) return false;
    var closeButton = drawer.querySelector('.popup-modal__toggle');
    event.preventDefault();
    event.stopImmediatePropagation();
    if (closeButton && typeof closeButton.click === 'function') {
      closeButton.click();
    } else if (typeof drawer.close === 'function') {
      drawer.close();
    } else {
      return false;
    }
    window.setTimeout(syncCartDrawer, 0);
    window.setTimeout(syncCartDrawer, 80);
    return true;
  }

  function clearCartDrawerFocusTimers() {
    for (var i = 0; i < cartDrawerFocusTimers.length; i++) {
      clearTimeout(cartDrawerFocusTimers[i]);
    }
    cartDrawerFocusTimers = [];
  }

  function scheduleCartDrawerCloseFocus(drawer) {
    clearCartDrawerFocusTimers();
    var delays = [0, 60, 180, 350];
    for (var i = 0; i < delays.length; i++) {
      (function (delay) {
        cartDrawerFocusTimers.push(
          setTimeout(function () {
            if (!cartDrawerIsOpen(drawer)) return;
            var closeButton = drawer.querySelector('.popup-modal__toggle');
            if (closeButton && document.activeElement !== closeButton) focusElement(closeButton);
          }, delay)
        );
      })(delays[i]);
    }
  }

  function rememberCartDrawerOpener(event) {
    var target = event && event.target;
    if (!target || !target.closest) return;
    var drawer = document.querySelector('cart-drawer.cart-drawer-container');
    if (cartDrawerIsOpen(drawer) || (drawer && drawer.contains(target))) return;
    var opener = target.closest(
      '#cart-icon-bubble, #cart-icon-bubble-short, #cart-icon-bubble--mobile, ' +
        '#cart-icon-bubble--mobile-short, button[name="add"], .product-form__submit'
    );
    if (opener) cartDrawerOpener = opener;
  }

  /* SD-R2-005: Close first, exclude background, contain Tab, restore opener. */
  function syncCartDrawer() {
    var drawer = document.querySelector('cart-drawer.cart-drawer-container');
    if (!drawer) return;
    var open = cartDrawerIsOpen(drawer);

    if (open) {
      setPopupBackgroundInert(drawer, 'data-dive-r2-cart-inert', true);
      if (!cartDrawerWasOpen) {
        cartDrawerWasOpen = true;
        var closeButton = drawer.querySelector('.popup-modal__toggle');
        if (typeof window.trapFocus === 'function' && closeButton) {
          window.trapFocus(drawer, closeButton);
        }
        scheduleCartDrawerCloseFocus(drawer);
      }
    } else {
      setPopupBackgroundInert(null, 'data-dive-r2-cart-inert', false);
      clearCartDrawerFocusTimers();
      if (cartDrawerWasOpen) {
        cartDrawerWasOpen = false;
        var active = document.activeElement;
        var needsReturn =
          !active ||
          active === document.body ||
          active === document.documentElement ||
          drawer.contains(active);
        var opener = cartDrawerOpener;
        if (needsReturn && opener && document.contains(opener)) {
          setTimeout(function () {
            if (!cartDrawerIsOpen(drawer)) focusElement(opener);
          }, 40);
        }
      }
    }
  }

  function clearCartQuantityTimers() {
    for (var i = 0; i < cartQuantityTimers.length; i++) clearTimeout(cartQuantityTimers[i]);
    cartQuantityTimers = [];
  }

  function findCartQuantityInput(variantId) {
    var inputs = document.querySelectorAll(
      '#cart input.quantity__input[data-quantity-variant-id]'
    );
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('data-quantity-variant-id') === variantId) return inputs[i];
    }
    return null;
  }

  function ensureCartStatus() {
    /* Keep this separate from the theme-owned region, which is replaced and
       overwritten during every cart section render. */
    var status = document.getElementById('sigonna-dive-r2-cart-status');
    if (!status) {
      status = document.createElement('p');
      status.id = 'sigonna-dive-r2-cart-status';
      status.className = 'visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      document.body.appendChild(status);
    }
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    return status;
  }

  function announceCartStatus(message) {
    var status = ensureCartStatus();
    status.textContent = '';
    setTimeout(function () {
      if (document.contains(status)) status.textContent = message;
    }, 40);
  }

  function cartQuantityFocusTarget(pending) {
    var input = findCartQuantityInput(pending.variantId);
    if (!input) return null;
    var wrapper = input.closest('quantity-input');
    var control = wrapper && wrapper.querySelector('button[name="' + pending.action + '"]');
    return control && isVisible(control) ? control : input;
  }

  function restoreCartQuantityFocus(pending) {
    if (!pending || cartQuantityPending !== pending) return;
    var target = cartQuantityFocusTarget(pending);
    if (!target) return;
    var active = document.activeElement;
    var focusWasLost =
      !active ||
      active === document.body ||
      active === document.documentElement ||
      !document.contains(active);
    if (focusWasLost) focusElement(target);
  }

  function stabilizeCartQuantityUpdate(pending) {
    clearCartQuantityTimers();
    var delays = [0, 100, 250, 500, 900, 1500, 2400];
    for (var i = 0; i < delays.length; i++) {
      (function (delay) {
        cartQuantityTimers.push(
          setTimeout(function () {
            restoreCartQuantityFocus(pending);
          }, delay)
        );
      })(delays[i]);
    }
    cartQuantityTimers.push(
      setTimeout(function () {
        if (cartQuantityPending === pending) cartQuantityPending = null;
      }, 2800)
    );
  }

  function finishCartQuantityUpdate() {
    var pending = cartQuantityPending;
    if (!pending) return false;
    if (pending.detected) {
      restoreCartQuantityFocus(pending);
      return true;
    }
    var input = findCartQuantityInput(pending.variantId);
    var newQuantity = input ? parseInt(input.value, 10) : 0;
    if (input && (isNaN(newQuantity) || newQuantity === pending.oldQuantity)) {
      pending.missingSince = 0;
      return false;
    }
    if (!input) {
      if (!pending.missingSince) {
        pending.missingSince = Date.now();
        return false;
      }
      if (Date.now() - pending.missingSince < 300) return false;
    }

    var target = null;
    if (input) {
      target = cartQuantityFocusTarget(pending);
      announceCartStatus('Cart updated. Quantity ' + newQuantity + '.');
    } else {
      target = document.querySelector('main h1, #MainContent h1, main');
      if (target && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      announceCartStatus(pending.product + ' removed from cart.');
    }
    if (target) focusElement(target);
    pending.detected = true;
    stabilizeCartQuantityUpdate(pending);
    return true;
  }

  function scheduleCartQuantityFinish() {
    clearCartQuantityTimers();
    var delays = [0, 80, 200, 450, 800, 1400, 2400, 3600, 5000];
    for (var i = 0; i < delays.length; i++) {
      (function (delay) {
        cartQuantityTimers.push(setTimeout(finishCartQuantityUpdate, delay));
      })(delays[i]);
    }
    cartQuantityTimers.push(
      setTimeout(function () {
        cartQuantityPending = null;
      }, 7000)
    );
  }

  function rememberCartQuantity(event) {
    var target = event && event.target;
    if (!target || !target.closest) return;
    var control = target.closest('#cart quantity-input button[name="minus"], #cart quantity-input button[name="plus"]');
    if (!control) return;
    var input = control.closest('quantity-input').querySelector('input.quantity__input');
    if (!input) return;
    var oldQuantity = parseInt(input.value, 10);
    var product = cleanText(input.getAttribute('aria-label')).replace(/^Quantity for\s+/i, '');
    cartQuantityPending = {
      variantId: input.getAttribute('data-quantity-variant-id') || '',
      oldQuantity: isNaN(oldQuantity) ? 0 : oldQuantity,
      action: control.getAttribute('name'),
      product: product || 'Item',
      missingSince: 0,
      detected: false
    };
    ensureCartStatus().textContent = '';
    scheduleCartQuantityFinish();
  }

  function confirmCartQuantityUpdate() {
    if (cartQuantityPending) scheduleCartQuantityFinish();
  }

  function installCartUpdatedConfirmation() {
    document.addEventListener('cart:updated', confirmCartQuantityUpdate);
    var jq = window.jQuery_T4NT || window.jQuery;
    if (jq && jq.fn) {
      jq(document)
        .off('cart:updated.sigonnaDiveR2')
        .on('cart:updated.sigonnaDiveR2', confirmCartQuantityUpdate);
    }
  }

  function runRepairs() {
    syncFilterDialog();
    syncJudgeReviewModals();
    normalizeCollapsibleHeadings();
    syncCartDrawer();
  }

  function scheduleRepairs() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      runRepairs();
    }, 70);
  }

  function start() {
    runRepairs();
    installCartUpdatedConfirmation();
    document.addEventListener('shopify:section:load', scheduleRepairs);
    document.addEventListener('cart:updated', scheduleRepairs);
    document.addEventListener('click', function (event) {
      rememberCartDrawerOpener(event);
      rememberCartQuantity(event);
    }, true);
    document.addEventListener('keydown', function (event) {
      if (closeCartDrawerOnEscape(event)) return;
      if (event.key === 'Enter' || event.key === ' ') {
        rememberCartDrawerOpener(event);
        rememberCartQuantity(event);
      }
      trapActivePopupTab(event);
    }, true);

    var observer = new MutationObserver(function (mutations) {
      if (cartQuantityPending) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'childList') {
            setTimeout(finishCartQuantityUpdate, 80);
            break;
          }
        }
      }
      scheduleRepairs();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'open']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/**
 * SigonnaDive R3 accessibility remediation (2026-08-06).
 *
 * Limited to confirmed R3 failures: dynamic facet names/focus/isolation,
 * cart removal focus/status and localization speech, rare-state headings,
 * and the indefinite low-stock pulse.
 */
(function () {
  'use strict';

  if (window.__sigonnaDiveR3RemediationLoaded) return;
  window.__sigonnaDiveR3RemediationLoaded = true;

  var scheduled = false;
  var filterApplyPending = false;
  var filterAnnouncementKey = '';
  var desktopFilterPending = null;
  var desktopFilterTimers = [];
  var facetDrawerWasOpen = false;
  var cartRemovalPending = null;
  var cartRemovalTimers = [];
  var FILTER_STORAGE_KEY = 'sigonna-dive-r3-filter-applied';
  var CART_STORAGE_KEY = 'sigonna-dive-r3-cart-remove';

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function focusElement(element) {
    if (!element || typeof element.focus !== 'function') return false;
    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      try {
        element.focus();
      } catch (fallbackError) {
        return false;
      }
    }
    return document.activeElement === element;
  }

  function isVisible(element) {
    if (!element || element.disabled || element.inert) return false;
    if (element.getAttribute('aria-hidden') === 'true') return false;
    if (typeof element.getClientRects === 'function' && !element.getClientRects().length) {
      return false;
    }
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function ensureStatus() {
    var existing = document.getElementById('dive-r2-cart-status');
    if (existing) return existing;
    var status = document.getElementById('dive-r3-status');
    if (status) return status;
    status = document.createElement('div');
    status.id = 'dive-r3-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    status.style.position = 'absolute';
    status.style.width = '1px';
    status.style.height = '1px';
    status.style.margin = '-1px';
    status.style.padding = '0';
    status.style.overflow = 'hidden';
    status.style.clip = 'rect(0 0 0 0)';
    status.style.whiteSpace = 'nowrap';
    status.style.border = '0';
    document.body.appendChild(status);
    return status;
  }

  function announce(message) {
    var status = ensureStatus();
    if (!status || !message) return;
    status.textContent = '';
    window.setTimeout(function () {
      status.textContent = message;
    }, 20);
  }

  function saveSession(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      /* Session storage is an optional reload bridge. */
    }
  }

  function takeSession(key) {
    try {
      var raw = window.sessionStorage.getItem(key);
      if (!raw) return null;
      window.sessionStorage.removeItem(key);
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  /* SD-R3-001: name the icon-only active-facet reset control. */
  function syncActiveFacetNames() {
    var controls = document.querySelectorAll('a.active-facets__button-remove[role="button"]');
    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];
      if (!cleanText(control.getAttribute('aria-label')) && !cleanText(control.textContent)) {
        control.setAttribute('aria-label', 'Remove all filters');
        control.setAttribute('data-dive-r3-active-filter-name', 'true');
      }
    }
  }

  function parkElement(element, marker, parked) {
    if (!element) return;
    if (parked) {
      if (element.hasAttribute(marker)) return;
      if (!element.hasAttribute(marker)) {
        var hidden = element.hasAttribute('aria-hidden')
          ? element.getAttribute('aria-hidden')
          : '__missing__';
        element.setAttribute(marker, (element.inert ? '1' : '0') + '|' + hidden);
      }
      try {
        element.inert = true;
      } catch (error) {
        element.setAttribute('inert', '');
      }
      element.setAttribute('aria-hidden', 'true');
      return;
    }

    if (!element.hasAttribute(marker)) return;
    var parts = element.getAttribute(marker).split('|');
    element.removeAttribute(marker);
    try {
      element.inert = parts[0] === '1';
    } catch (restoreError) {
      if (parts[0] === '1') element.setAttribute('inert', '');
      else element.removeAttribute('inert');
    }
    if (parts[0] !== '1') element.removeAttribute('inert');
    if (parts[1] === '__missing__') element.removeAttribute('aria-hidden');
    else element.setAttribute('aria-hidden', parts[1]);
  }

  /* SD-R3-002: expose only the active nested-facet controls. */
  function syncNestedFacetIsolation() {
    var form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return;
    var marker = 'data-dive-r3-facet-parked';
    var drawer = document.getElementById('mobile-facets');
    var outerFooter = form.querySelector(
      ':scope > .facet-drawer__content > .mobile-facets__footer'
    );
    var details = form.querySelectorAll('.mobile-facets__details');

    if (!drawer || !drawer.open) {
      var staleExpanded = form.querySelectorAll(
        '.mobile-facets__details > summary[aria-expanded="true"]'
      );
      for (var s = 0; s < staleExpanded.length; s++) {
        staleExpanded[s].setAttribute('aria-expanded', 'false');
      }
      var closedParked = form.querySelectorAll('[' + marker + ']');
      for (var c = 0; c < closedParked.length; c++) {
        parkElement(closedParked[c], marker, false);
      }
      if (facetDrawerWasOpen) {
        facetDrawerWasOpen = false;
        var drawerOpener = drawer && drawer.querySelector(':scope > summary');
        var restoreDrawerFocus = function () {
          var currentFocus = document.activeElement;
          var safeToRestore =
            !currentFocus ||
            currentFocus === document.body ||
            currentFocus === document.documentElement ||
            !document.contains(currentFocus);
          if (safeToRestore && drawerOpener && isVisible(drawerOpener)) {
            focusElement(drawerOpener);
          }
        };
        var focusDelays = [0, 180, 500, 1000];
        for (var f = 0; f < focusDelays.length; f++) {
          window.setTimeout(restoreDrawerFocus, focusDelays[f]);
        }
      }
      return;
    }

    facetDrawerWasOpen = true;
    var active = form.querySelector(
      '.mobile-facets__details.details-opened, .mobile-facets__details.menu-opening'
    );
    if (!active) {
      var activeSummary = form.querySelector(
        '.mobile-facets__details > summary[aria-expanded="true"]'
      );
      active = activeSummary && activeSummary.closest('.mobile-facets__details');
    }
    if (active) {
      parkElement(outerFooter, marker, true);
      for (var i = 0; i < details.length; i++) {
        if (details[i] === active) {
          parkElement(details[i], marker, false);
        } else {
          parkElement(details[i], marker, true);
        }
      }
      return;
    }

    var parked = form.querySelectorAll('[' + marker + ']');
    for (var p = 0; p < parked.length; p++) parkElement(parked[p], marker, false);
  }

  function visibleProductCount() {
    var links = document.querySelectorAll('main a[href*="/products/"]');
    var unique = {};
    for (var i = 0; i < links.length; i++) {
      if (!isVisible(links[i])) continue;
      var href = (links[i].getAttribute('href') || '').split('?')[0];
      if (href) unique[href] = true;
    }
    return Object.keys(unique).length;
  }

  function filterInputLabel(input) {
    if (!input) return '';
    var labelledBy = cleanText(input.getAttribute('aria-labelledby'));
    if (labelledBy) {
      var ids = labelledBy.split(/\s+/);
      var parts = [];
      for (var i = 0; i < ids.length; i++) {
        var labelled = document.getElementById(ids[i]);
        if (labelled) parts.push(cleanText(labelled.textContent));
      }
      if (cleanText(parts.join(' '))) return cleanText(parts.join(' '));
    }
    var explicit = input.id && document.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
    return cleanText(
      input.getAttribute('aria-label') ||
      (explicit && explicit.textContent) ||
      (input.closest('label') && input.closest('label').textContent)
    );
  }

  function findDesktopFilterReplacement(pending) {
    var inputs = document.querySelectorAll(
      'facet-filters-form input[type="checkbox"]:not([disabled])'
    );
    var labelMatch = null;
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].closest('#FacetFiltersFormMobile,#mobile-facets')) continue;
      if (pending.id && inputs[i].id === pending.id) return inputs[i];
      if (
        pending.name &&
        inputs[i].name === pending.name &&
        (pending.value === '' || inputs[i].value === pending.value)
      ) return inputs[i];
      if (!labelMatch && pending.label && filterInputLabel(inputs[i]) === pending.label) {
        labelMatch = inputs[i];
      }
    }
    return labelMatch;
  }

  function clearDesktopFilterTimers() {
    for (var i = 0; i < desktopFilterTimers.length; i++) {
      window.clearTimeout(desktopFilterTimers[i]);
    }
    desktopFilterTimers = [];
  }

  function completeDesktopFilterApply() {
    if (!desktopFilterPending) return false;
    var replacement = findDesktopFilterReplacement(desktopFilterPending);
    var currentCount = visibleProductCount();
    var refreshed =
      !document.contains(desktopFilterPending.original) ||
      currentCount !== desktopFilterPending.initialCount ||
      window.location.search !== desktopFilterPending.initialSearch;
    if (!replacement || !refreshed) return false;

    var active = document.activeElement;
    var safeToRestore =
      !active ||
      active === document.body ||
      active === document.documentElement ||
      !document.contains(active) ||
      active === desktopFilterPending.original;
    if (safeToRestore && isVisible(replacement)) focusElement(replacement);

    announce(
      currentCount === 0
        ? 'Filters applied. No products found.'
        : 'Filters applied. ' + currentCount +
          (currentCount === 1 ? ' product shown.' : ' products shown.')
    );
    desktopFilterPending = null;
    clearDesktopFilterTimers();
    return true;
  }

  function beginDesktopFilterApply(input) {
    clearDesktopFilterTimers();
    desktopFilterPending = {
      original: input,
      id: input.id || '',
      name: input.name || '',
      value: input.value || '',
      label: filterInputLabel(input),
      initialCount: visibleProductCount(),
      initialSearch: window.location.search
    };
    var delays = [80, 180, 350, 700, 1200, 2200];
    for (var i = 0; i < delays.length; i++) {
      desktopFilterTimers.push(window.setTimeout(completeDesktopFilterApply, delays[i]));
    }
  }

  function completeFilterApply() {
    var details = document.getElementById('mobile-facets');
    var dialogOpen = !!(details && details.open);
    if (dialogOpen) return false;
    var active = document.activeElement;
    var safeToRestore = !active || active === document.body || active === document.documentElement;
    if (!safeToRestore && active.closest) {
      safeToRestore = !!active.closest('#mobile-facets');
    }
    var opener = details && details.querySelector(':scope > summary');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    if (safeToRestore && opener && isVisible(opener)) focusElement(opener);

    var count = visibleProductCount();
    var key = window.location.pathname + window.location.search + '|' + count;
    if (key !== filterAnnouncementKey) {
      filterAnnouncementKey = key;
      announce(
        count === 0
          ? 'Filters applied. No products found.'
          : 'Filters applied. ' + count + (count === 1 ? ' product shown.' : ' products shown.')
      );
    }
    filterApplyPending = false;
    return true;
  }

  function scheduleFilterApplyCompletion() {
    var delays = [100, 350, 800, 1600];
    for (var i = 0; i < delays.length; i++) {
      window.setTimeout(function () {
        if (filterApplyPending) completeFilterApply();
      }, delays[i]);
    }
  }

  function beginFilterApply() {
    filterApplyPending = true;
    saveSession(FILTER_STORAGE_KEY, { path: window.location.pathname, at: Date.now() });
    scheduleFilterApplyCompletion();
  }

  function restoreFilterApplyAfterLoad() {
    var stored = takeSession(FILTER_STORAGE_KEY);
    if (!stored || !/^\/collections\//.test(window.location.pathname)) return;
    filterApplyPending = true;
    scheduleFilterApplyCompletion();
  }

  function normalizeCartTranslationStatus() {
    var statuses = document.querySelectorAll('[role="status"], [aria-live]');
    for (var i = 0; i < statuses.length; i++) {
      var text = cleanText(statuses[i].textContent);
      var match = text.match(
        /^Translation missing:\s*en\.sections\.cart\.new_estimated_total:\s*(.+)$/
      );
      if (!match) continue;
      statuses[i].textContent = 'Estimated total: ' + match[1];
      statuses[i].setAttribute('data-dive-r3-cart-total-normalized', 'true');
    }
  }

  function clearCartRemovalTimers() {
    for (var i = 0; i < cartRemovalTimers.length; i++) {
      window.clearTimeout(cartRemovalTimers[i]);
    }
    cartRemovalTimers = [];
  }

  function cartRemoveStillPresent(name) {
    var controls = document.querySelectorAll('a[aria-label^="Remove "][href*="/cart/change"]');
    for (var i = 0; i < controls.length; i++) {
      if (cleanText(controls[i].getAttribute('aria-label')) === 'Remove ' + name) return true;
    }
    return false;
  }

  function cartHeaderCountText() {
    var controls = document.querySelectorAll('[aria-label^="Cart,"]');
    for (var i = 0; i < controls.length; i++) {
      var label = cleanText(controls[i].getAttribute('aria-label'));
      if (label) return label.replace(/^Cart,\s*/, '');
    }
    return '';
  }

  function completeCartRemoval() {
    if (!cartRemovalPending || cartRemoveStillPresent(cartRemovalPending.name)) return false;
    normalizeCartTranslationStatus();

    var active = document.activeElement;
    var safeToRestore =
      !active ||
      active === document.body ||
      active === document.documentElement ||
      !document.contains(active);
    var emptyHeading = null;
    var headings = document.querySelectorAll('main h1');
    for (var h = 0; h < headings.length; h++) {
      if (/Your Cart is Empty/i.test(cleanText(headings[h].textContent))) {
        emptyHeading = headings[h];
        break;
      }
    }

    var message = '';
    if (emptyHeading) {
      if (safeToRestore) {
        if (!emptyHeading.hasAttribute('tabindex')) {
          emptyHeading.setAttribute('tabindex', '-1');
          emptyHeading.setAttribute('data-dive-r3-empty-cart-focus', 'true');
        }
        focusElement(emptyHeading);
      }
      message = cartRemovalPending.name + ' removed. Cart is empty.';
    } else {
      var next = document.querySelector(
        'main input[aria-label^="Quantity for"], main a[href*="/products/"]'
      );
      if (safeToRestore && next && isVisible(next)) focusElement(next);
      var countText = cartHeaderCountText();
      message = cartRemovalPending.name + ' removed.' + (countText ? ' ' + countText + ' remain.' : '');
    }

    announce(message);
    cartRemovalPending = null;
    clearCartRemovalTimers();
    try {
      window.sessionStorage.removeItem(CART_STORAGE_KEY);
    } catch (error) {
      /* Optional reload bridge only. */
    }
    return true;
  }

  function scheduleCartRemovalCompletion() {
    clearCartRemovalTimers();
    var delays = [120, 350, 800, 1400, 2400];
    for (var i = 0; i < delays.length; i++) {
      cartRemovalTimers.push(
        window.setTimeout(function () {
          completeCartRemoval();
        }, delays[i])
      );
    }
  }

  function beginCartRemoval(control) {
    var label = cleanText(control.getAttribute('aria-label'));
    var name = label.replace(/^Remove\s+/, '');
    if (!name) return;
    cartRemovalPending = { name: name };
    saveSession(CART_STORAGE_KEY, cartRemovalPending);
    scheduleCartRemovalCompletion();
  }

  function restoreCartRemovalAfterLoad() {
    var stored = takeSession(CART_STORAGE_KEY);
    if (!stored || !stored.name || window.location.pathname !== '/cart') return;
    cartRemovalPending = { name: stored.name };
    scheduleCartRemovalCompletion();
  }

  function replaceEdgeHeading(element) {
    if (!element || element.hasAttribute('data-dive-r3-heading-replaced')) return;
    var replacement = document.createElement('div');
    for (var i = 0; i < element.attributes.length; i++) {
      var attribute = element.attributes[i];
      if (attribute.name === 'role' || attribute.name === 'aria-level') continue;
      replacement.setAttribute(attribute.name, attribute.value);
    }
    replacement.setAttribute('role', 'heading');
    replacement.setAttribute('aria-level', '2');
    replacement.setAttribute('data-dive-r3-heading-replaced', 'true');
    while (element.firstChild) replacement.appendChild(element.firstChild);
    element.parentNode.replaceChild(replacement, element);
  }

  /* SD-R3-006: replace native edge-state H4/H6 elements, not just aria-level them. */
  function syncEdgeHeadings() {
    var linked = document.querySelectorAll('.product-linked-variants__heading > h6');
    for (var i = 0; i < linked.length; i++) replaceEdgeHeading(linked[i]);

    var noResults = document.querySelectorAll('h4[aria-live][aria-atomic]');
    for (var n = 0; n < noResults.length; n++) {
      if (/^No results found/i.test(cleanText(noResults[n].textContent))) {
        replaceEdgeHeading(noResults[n]);
      }
    }
  }

  /* SD-R3-007: the low-stock pulse is non-essential and otherwise infinite. */
  function syncLowStockMotion() {
    var pulses = document.querySelectorAll('.animation-pulse');
    for (var i = 0; i < pulses.length; i++) {
      var animation = window.getComputedStyle(pulses[i]).animationName || '';
      if (animation.indexOf('icon_pulse') === -1) continue;
      pulses[i].style.animation = 'none';
      pulses[i].setAttribute('data-dive-r3-motion-stopped', 'true');
    }
  }

  function sync() {
    scheduled = false;
    syncActiveFacetNames();
    syncNestedFacetIsolation();
    normalizeCartTranslationStatus();
    syncEdgeHeadings();
    syncLowStockMotion();
    if (filterApplyPending) completeFilterApply();
    if (desktopFilterPending) completeDesktopFilterApply();
    if (cartRemovalPending) completeCartRemoval();
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(sync, 0);
  }

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('input[type="checkbox"]')) return;
      if (!input.closest('facet-filters-form')) return;
      if (input.closest('#FacetFiltersFormMobile,#mobile-facets')) return;
      beginDesktopFilterApply(input);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target && event.target.closest ? event.target.closest('button, a') : null;
      if (!target) return;

      if (
        target.closest('#FacetFiltersFormMobile') &&
        target.matches('button.popup-modal__toggle__close') &&
        /^Apply\b/.test(cleanText(target.textContent))
      ) {
        beginFilterApply();
      }

      if (
        target.matches('a[aria-label^="Remove "][href*="/cart/change"]') &&
        target.closest('main')
      ) {
        beginCartRemoval(target);
      }
    },
    true
  );

  var observer = new MutationObserver(scheduleSync);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'aria-hidden', 'aria-label', 'aria-expanded']
  });

  restoreFilterApplyAfterLoad();
  restoreCartRemovalAfterLoad();
  scheduleSync();
})();

/* SIGONNA-DIVE-ADA-R4-20260810 */
/**
 * Sigonna Dive R4 accessibility remediation (2026-08-10).
 * Full-inventory axe + exact installed-WAVE root causes; idempotent for
 * Shopify/app dynamic replacements.
 */
(function () {
  'use strict';

  if (window.__sigonnaDiveR4RemediationLoaded) return;
  window.__sigonnaDiveR4RemediationLoaded = true;

  var repairScheduled = false;

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isOpaquePaint(value) {
    if (!value || value === 'transparent') return false;
    var rgba = value.match(/^rgba\([^,]+,[^,]+,[^,]+,\s*([\d.]+)\)$/i);
    return !rgba || Number(rgba[1]) > 0;
  }

  function isLightTextColor(value) {
    var rgb = (value || '').match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (!rgb) return false;
    return Number(rgb[1]) >= 220 && Number(rgb[2]) >= 220 && Number(rgb[3]) >= 220;
  }

  function setHeadingLevel(element, level) {
    if (!element) return;
    var nativeMatch = element.tagName && element.tagName.match(/^H([1-6])$/);
    if (nativeMatch && Number(nativeMatch[1]) !== Number(level)) {
      var semantic = element.querySelector(
        ':scope > [data-dive-r15-heading-text],:scope > [data-dive-r2-heading-text]'
      );
      if (!semantic) {
        semantic = document.createElement('span');
        while (element.firstChild) semantic.appendChild(element.firstChild);
        element.appendChild(semantic);
      }
      element.setAttribute('role', 'presentation');
      element.removeAttribute('aria-level');
      element.removeAttribute('data-dive-r4-heading-level');
      element.setAttribute('data-dive-r15-heading-wrapper', 'true');
      semantic.setAttribute('role', 'heading');
      semantic.setAttribute('aria-level', String(level));
      semantic.setAttribute('data-dive-r2-heading-text', 'true');
      semantic.setAttribute('data-dive-r15-heading-text', 'true');
      return;
    }
    element.setAttribute('role', 'heading');
    element.setAttribute('aria-level', String(level));
    element.setAttribute('data-dive-r4-heading-level', String(level));
  }

  function repairDiscountLabels() {
    var inputs = document.querySelectorAll('input#cart-discount');
    for (var i = 0; i < inputs.length; i++) {
      var form = inputs[i].closest('form') || document;
      var labels = form.querySelectorAll('label[for="cart-discount"]');
      if (labels.length < 2) continue;
      for (var j = 0; j < labels.length; j++) {
        if (labels[j].classList.contains('field__label')) continue;
        var replacement = document.createElement('span');
        for (var attributeIndex = 0; attributeIndex < labels[j].attributes.length; attributeIndex++) {
          var attribute = labels[j].attributes[attributeIndex];
          if (attribute.name === 'for') continue;
          replacement.setAttribute(attribute.name, attribute.value);
        }
        replacement.innerHTML = labels[j].innerHTML;
        replacement.setAttribute('aria-hidden', 'true');
        replacement.setAttribute('data-dive-r4-redundant-label', 'true');
        labels[j].replaceWith(replacement);
      }
    }
  }

  function labelDeferredMedia() {
    var buttons = document.querySelectorAll('button.deferred-media__poster');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      if (cleanText(button.getAttribute('aria-label')) || cleanText(button.getAttribute('aria-labelledby'))) {
        continue;
      }
      var image = button.querySelector('img');
      var mediaName = image ? cleanText(image.getAttribute('alt')) : '';
      var action = button.classList.contains('deferred-media__poster-model')
        ? 'View 3D product model'
        : 'Play product video';
      button.setAttribute('aria-label', mediaName ? action + ': ' + mediaName : action);
      button.setAttribute('data-dive-r4-media-label', 'true');
    }
  }

  function repairScrollableGalleries() {
    var galleries = document.querySelectorAll('.swiper-thumb__container--horizontal');
    for (var i = 0; i < galleries.length; i++) {
      var gallery = galleries[i];
      if (!gallery.hasAttribute('tabindex')) gallery.setAttribute('tabindex', '0');
      gallery.setAttribute('role', 'region');
      if (!cleanText(gallery.getAttribute('aria-label'))) {
        gallery.setAttribute('aria-label', 'Product media thumbnails');
      }
      gallery.setAttribute('data-dive-r4-scroll-region', 'true');
    }
  }

  function repairPseudoButtonBackgrounds() {
    var buttons = document.querySelectorAll('.btn__transition-text');
    for (var i = 0; i < buttons.length; i++) {
      var resting = window.getComputedStyle(buttons[i], '::before').backgroundColor;
      if (!isOpaquePaint(resting)) continue;
      buttons[i].style.setProperty('background-color', resting, 'important');
      buttons[i].setAttribute('data-dive-r4-resting-background', 'true');
    }
  }

  function repairImageTextContrast() {
    var cards = document.querySelectorAll(
      '.section-media-buttons-parent.banner__block-item-with-text .banner__block-item__content__items'
    );
    for (var i = 0; i < cards.length; i++) {
      var sample = cards[i].querySelector('h1,h2,h3,h4,h5,h6,p');
      if (!sample || !isLightTextColor(window.getComputedStyle(sample).color)) continue;
      cards[i].setAttribute('data-dive-r4-image-text-contrast', 'true');
    }
  }

  function repairLinkedVariantImages() {
    var images = document.querySelectorAll('.product-linked-variants__image img');
    for (var i = 0; i < images.length; i++) {
      images[i].setAttribute('alt', '');
      images[i].setAttribute('data-dive-r4-decorative-linked-image', 'true');
    }
  }

  function repairLandmarks() {
    var skipLink = document.querySelector('.skip-to-content-link');
    if (skipLink && !skipLink.closest('nav,[role="navigation"]')) {
      var nav = document.createElement('nav');
      nav.setAttribute('aria-label', 'Skip links');
      nav.setAttribute('data-dive-r4-skip-navigation', 'true');
      skipLink.parentNode.insertBefore(nav, skipLink);
      nav.appendChild(skipLink);
    }

    var benefits = document.querySelectorAll('.blurb-header__block__text');
    for (var i = 0; i < benefits.length; i++) {
      var owner = benefits[i].closest('.shopify-section, section');
      if (!owner || owner.closest('header,footer,main,nav,aside')) continue;
      owner.setAttribute('role', 'region');
      if (!cleanText(owner.getAttribute('aria-label'))) owner.setAttribute('aria-label', 'Store benefits');
      owner.setAttribute('data-dive-r4-benefits-region', 'true');
    }

    var stickyItems = document.querySelectorAll('.footer-sticky-nav__item');
    for (var j = 0; j < stickyItems.length; j++) {
      var stickyNav = stickyItems[j].closest('footer-sticky-nav,.footer-sticky-nav') || stickyItems[j].parentElement;
      if (!stickyNav || stickyNav === stickyItems[j]) stickyNav = stickyItems[j].parentElement;
      if (!stickyNav) continue;
      stickyNav.setAttribute('role', 'navigation');
      if (!cleanText(stickyNav.getAttribute('aria-label'))) {
        stickyNav.setAttribute('aria-label', 'Quick links');
      }
      stickyNav.setAttribute('data-dive-r4-sticky-navigation', 'true');
    }
  }

  function repairHeadings() {
    var headings = document.querySelectorAll('main h1,main h2,main h3,main h4,main h5,main h6');
    for (var i = 0; i < headings.length; i++) {
      if (cleanText(headings[i].textContent)) continue;
      var missingLevel = Number(headings[i].tagName.slice(1));
      for (var nextIndex = i + 1; nextIndex < headings.length; nextIndex++) {
        if (!cleanText(headings[nextIndex].textContent)) continue;
        var nextLevel = Number(headings[nextIndex].tagName.slice(1));
        if (nextLevel > missingLevel) setHeadingLevel(headings[nextIndex], missingLevel);
        break;
      }
      var computed = window.getComputedStyle(headings[i]);
      var bounds = headings[i].getBoundingClientRect();
      var spacer = document.createElement('div');
      for (var attributeIndex = 0; attributeIndex < headings[i].attributes.length; attributeIndex++) {
        var attribute = headings[i].attributes[attributeIndex];
        spacer.setAttribute(attribute.name, attribute.value);
      }
      spacer.innerHTML = headings[i].innerHTML;
      spacer.style.marginTop = computed.marginTop;
      spacer.style.marginRight = computed.marginRight;
      spacer.style.marginBottom = computed.marginBottom;
      spacer.style.marginLeft = computed.marginLeft;
      if (bounds.height > 0) spacer.style.minHeight = Math.ceil(bounds.height) + 'px';
      spacer.setAttribute('aria-hidden', 'true');
      spacer.setAttribute('data-dive-r4-empty-heading', 'true');
      headings[i].replaceWith(spacer);
    }

    var noProducts = document.querySelectorAll('#product-grid h4');
    for (var j = 0; j < noProducts.length; j++) {
      if (/^No products found/i.test(cleanText(noProducts[j].textContent))) {
        setHeadingLevel(noProducts[j], 2);
      }
    }

    if (location.pathname === '/search') {
      var searchHeadings = document.querySelectorAll('main h5.h4');
      for (var k = 0; k < searchHeadings.length; k++) setHeadingLevel(searchHeadings[k], 2);
    }

    var modalHeadings = document.querySelectorAll(
      '#HeaderSearch-Heading, external-searchcontent h4, .popup-modal__search h4'
    );
    for (var m = 0; m < modalHeadings.length; m++) setHeadingLevel(modalHeadings[m], 2);

    if (location.pathname === '/pages/brands' && !document.querySelector('main h1,main [role="heading"][aria-level="1"]')) {
      var brandHeading = document.querySelector('main h2,main h3,main h4,main h5,main h6');
      setHeadingLevel(brandHeading, 1);
    }
  }

  function repairPrivacyAndCaptchaLabels() {
    var optOut = document.getElementById('pc--browser-opt-out-checkbox');
    if (optOut && !cleanText(optOut.getAttribute('aria-label')) && !cleanText(optOut.getAttribute('aria-labelledby'))) {
      optOut.setAttribute('aria-label', 'Use browser opt-out preference');
      optOut.setAttribute('data-dive-r4-privacy-label', 'true');
    }

    var captchaResponses = document.querySelectorAll(
      'textarea[id^="g-recaptcha-response"],textarea[id^="h-captcha-response"]'
    );
    for (var i = 0; i < captchaResponses.length; i++) {
      captchaResponses[i].setAttribute('aria-label', 'CAPTCHA verification response');
      captchaResponses[i].setAttribute('aria-hidden', 'true');
      captchaResponses[i].setAttribute('tabindex', '-1');
      captchaResponses[i].setAttribute('data-dive-r4-captcha-response', 'true');
    }
  }

  function repairFacetGroups() {
    var details = document.querySelectorAll(
      'facet-filters-form details, facet-filters-form .facets__disclosure, .mobile-facets__details'
    );
    for (var i = 0; i < details.length; i++) {
      var checkboxes = details[i].querySelectorAll('input[type="checkbox"]');
      if (!checkboxes.length) continue;
      var group = details[i].querySelector('ul') || details[i].querySelector('.facets__list');
      if (!group) continue;
      var summary = details[i].querySelector(':scope > summary') || details[i].querySelector('summary');
      var name = summary ? cleanText(summary.textContent) : '';
      if (/^(UL|OL)$/.test(group.tagName)) {
        group.removeAttribute('role');
        group.setAttribute('data-dive-r5-native-facet-list', 'true');
        group.setAttribute('data-dive-r10-stable-facet-list', 'true');
      } else {
        group.setAttribute('role', 'group');
      }
      if (name) group.setAttribute('aria-label', name);
      group.setAttribute('data-dive-r4-facet-group', 'true');
    }
  }

  function removeRedundantTitles() {
    var titled = document.querySelectorAll('[title]');
    for (var i = 0; i < titled.length; i++) {
      var title = cleanText(titled[i].getAttribute('title'));
      var label = cleanText(titled[i].getAttribute('aria-label')) || cleanText(titled[i].textContent);
      if (title && label && title.toLowerCase() === label.toLowerCase()) {
        titled[i].removeAttribute('title');
        titled[i].setAttribute('data-dive-r4-redundant-title-removed', 'true');
      }
    }
  }

  function repair() {
    repairScheduled = false;
    repairDiscountLabels();
    labelDeferredMedia();
    repairScrollableGalleries();
    repairPseudoButtonBackgrounds();
    repairImageTextContrast();
    repairLinkedVariantImages();
    repairLandmarks();
    repairHeadings();
    repairPrivacyAndCaptchaLabels();
    repairFacetGroups();
    removeRedundantTitles();
  }

  function scheduleRepair() {
    if (repairScheduled) return;
    repairScheduled = true;
    window.requestAnimationFrame(repair);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repair, { once: true });
  } else {
    repair();
  }
  window.setTimeout(repair, 300);
  window.setTimeout(repair, 1200);
  window.setTimeout(repair, 3500);
  new MutationObserver(scheduleRepair).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* SIGONNA-DIVE-ADA-R5-20260810 */
/**
 * Restore native list semantics after the R4 facet-group repair. A role of
 * group on UL/OL invalidates their LI children; the accessible list name can
 * remain without replacing the native list role.
 */
(function () {
  'use strict';

  if (window.__sigonnaDiveR5FacetListLoaded) return;
  window.__sigonnaDiveR5FacetListLoaded = true;

  var scheduled = false;

  function repairFacetLists() {
    scheduled = false;
    var lists = document.querySelectorAll(
      'ul[data-dive-r4-facet-group][role="group"],ol[data-dive-r4-facet-group][role="group"]'
    );
    for (var i = 0; i < lists.length; i++) {
      lists[i].removeAttribute('role');
      lists[i].setAttribute('data-dive-r5-native-facet-list', 'true');
    }
  }

  function scheduleRepair() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(repairFacetLists);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairFacetLists, { once: true });
  } else {
    repairFacetLists();
  }
  window.setTimeout(repairFacetLists, 400);
  window.setTimeout(repairFacetLists, 1400);
  window.setTimeout(repairFacetLists, 3700);
  new MutationObserver(scheduleRepair).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['role'],
    childList: true,
    subtree: true
  });
})();

/* SIGONNA-DIVE-ADA-R6-20260810 */
/**
 * Reduce scanner-only contrast and heading noise without changing the
 * storefront's resting or pointer-hover presentation. The repairs are
 * idempotent and also cover Shopify cart-drawer replacements.
 */
(function () {
  'use strict';

  if (window.__sigonnaDiveR6ScannerNoiseLoaded) return;
  window.__sigonnaDiveR6ScannerNoiseLoaded = true;

  var repairPending = false;

  function replaceTag(element, tagName, configure) {
    if (!element || !element.parentNode) return null;
    var replacement = document.createElement(tagName);
    for (var i = 0; i < element.attributes.length; i++) {
      var attribute = element.attributes[i];
      replacement.setAttribute(attribute.name, attribute.value);
    }
    while (element.firstChild) replacement.appendChild(element.firstChild);
    if (configure) configure(replacement, element);
    element.parentNode.replaceChild(replacement, element);
    return replacement;
  }

  function repairScannerNoise() {
    var tooltipControls = document.querySelectorAll(
      'a.global__tooltip--hover, button.global__tooltip--hover'
    );
    for (var t = 0; t < tooltipControls.length; t++) {
      if ((tooltipControls[t].getAttribute('aria-label') || '').trim()) continue;
      var tooltip = tooltipControls[t].querySelector('.global__tooltip__content');
      var tooltipName = tooltip ? (tooltip.textContent || '').trim().replace(/\s+/g, ' ') : '';
      if (!tooltipName) continue;
      tooltipControls[t].setAttribute('aria-label', tooltipName);
      tooltipControls[t].setAttribute('data-dive-r6-tooltip-name', 'true');
    }

    var logo = document.querySelector('header-desktop a[aria-label] img.header__heading-logo[alt]');
    if (
      logo &&
      logo.closest('a').getAttribute('aria-label').trim() === logo.getAttribute('alt').trim()
    ) {
      logo.setAttribute('alt', '');
      logo.setAttribute('data-dive-r6-redundant-alt', 'decorative-child');
    }

    var presentationalHeadings = document.querySelectorAll(
      'cart-drawer h4[role="presentation"], cart-drawer h6[role="presentation"]'
    );
    for (var i = 0; i < presentationalHeadings.length; i++) {
      replaceTag(presentationalHeadings[i], 'div', function (replacement) {
        replacement.removeAttribute('aria-level');
        replacement.setAttribute('data-dive-r6-native-heading-wrapper', 'replaced');
      });
    }

    var emptyHeadings = document.querySelectorAll('cart-drawer h4');
    for (var h = 0; h < emptyHeadings.length; h++) {
      if (!/Your Cart is Empty/i.test(emptyHeadings[h].textContent || '')) continue;
      replaceTag(emptyHeadings[h], 'div', function (replacement) {
        replacement.setAttribute('role', 'heading');
        replacement.setAttribute('aria-level', '2');
        replacement.setAttribute('data-dive-r6-empty-drawer-heading', 'true');
      });
    }

    var subtotalValues = document.querySelectorAll('cart-drawer p.totals__subtotal-value');
    for (var p = 0; p < subtotalValues.length; p++) {
      replaceTag(subtotalValues[p], 'span', function (replacement, original) {
        replacement.style.display = window.getComputedStyle(original).display;
        replacement.setAttribute('data-dive-r6-subtotal-value', 'not-heading');
      });
    }
  }

  function scheduleRepair() {
    if (repairPending) return;
    repairPending = true;
    window.requestAnimationFrame(function () {
      repairPending = false;
      repairScannerNoise();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairScannerNoise, { once: true });
  } else {
    repairScannerNoise();
  }
  window.setTimeout(repairScannerNoise, 400);
  window.setTimeout(repairScannerNoise, 1400);
  window.setTimeout(repairScannerNoise, 3700);
  new MutationObserver(scheduleRepair).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* SIGONNA-DIVE-ADA-R9-20260811 */

/* SIGONNA-DIVE-ADA-R10-CANDIDATE-20260812 */

/* SIGONNA-DIVE-ADA-R12-CANDIDATE-20260812 */
(function () {
  'use strict';

  if (window.__sigonnaDiveR12DeferredMediaTabOrderLoaded) return;
  window.__sigonnaDiveR12DeferredMediaTabOrderLoaded = true;

  var marker = 'data-dive-r12-hidden-poster-tabindex';
  var absent = '__absent__';
  var scheduled = false;

  function repairDeferredMediaTabOrder() {
    scheduled = false;
    var buttons = document.querySelectorAll('button.deferred-media__poster');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var hiddenByLoadedMedia = button.matches(
        'deferred-media[loaded] > button.deferred-media__poster'
      );
      if (hiddenByLoadedMedia) {
        if (!button.hasAttribute(marker)) {
          var previous = button.getAttribute('tabindex');
          button.setAttribute(marker, previous === null ? absent : previous);
        }
        button.setAttribute('tabindex', '-1');
        continue;
      }
      if (!button.hasAttribute(marker)) continue;
      var saved = button.getAttribute(marker);
      if (saved === absent) button.removeAttribute('tabindex');
      else button.setAttribute('tabindex', saved);
      button.removeAttribute(marker);
    }
  }

  function scheduleRepair() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(repairDeferredMediaTabOrder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairDeferredMediaTabOrder, { once: true });
  } else {
    repairDeferredMediaTabOrder();
  }
  window.setTimeout(repairDeferredMediaTabOrder, 400);
  window.setTimeout(repairDeferredMediaTabOrder, 1400);
  window.setTimeout(repairDeferredMediaTabOrder, 3700);
  new MutationObserver(scheduleRepair).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['loaded'],
    childList: true,
    subtree: true
  });
})();

/* SIGONNA-DIVE-ADA-R13-NVDA-20260813 */
(function () {
  'use strict';

  if (window.__sigonnaDiveR13NvdaRemediationLoaded) return;
  window.__sigonnaDiveR13NvdaRemediationLoaded = true;

  var repairPending = false;
  var generatedOptionId = 0;
  var generatedMenuId = 0;
  var menuStyleId = 'dive-r13-keyboard-megamenu-style';

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function plural(count, one, many) {
    return count + ' ' + (count === 1 ? one : many);
  }

  function predictiveWidget(input) {
    return input && input.closest ? input.closest('predictive-search') : null;
  }

  function predictiveScope(input) {
    if (!input || !input.closest) return null;
    return input.closest('.popup-modal__search') || predictiveWidget(input);
  }

  function normalizePredictiveListbox(input) {
    var scope = predictiveScope(input);
    var results = scope && scope.querySelector('#predictive-search-results');
    if (!results) return;
    var candidates = results.querySelectorAll('[role="option"]');
    for (var i = 0; i < candidates.length; i++) {
      var candidate = candidates[i];
      if (candidate.matches('a[href],button')) {
        if (candidate.closest('#predictive-search-option-search-keywords')) {
          candidate.removeAttribute('role');
          candidate.removeAttribute('aria-selected');
        }
        continue;
      }
      var action = candidate.querySelector('a[href],button');
      if (!action) continue;
      candidate.setAttribute('role', 'presentation');
      candidate.removeAttribute('aria-selected');
      if (candidate.id === 'predictive-search-option-search-keywords') {
        action.removeAttribute('role');
        action.removeAttribute('aria-selected');
        continue;
      }
      action.setAttribute('role', 'option');
      if (!action.hasAttribute('aria-selected')) action.setAttribute('aria-selected', 'false');
      if (!action.id) {
        generatedOptionId += 1;
        action.id = (candidate.id || 'dive-r13-predictive-option-' + generatedOptionId) + '-action';
      }
    }
    var nestedListboxes = results.querySelectorAll('ul,ol');
    for (var listIndex = 0; listIndex < nestedListboxes.length; listIndex++) {
      nestedListboxes[listIndex].setAttribute('role', 'presentation');
      nestedListboxes[listIndex].removeAttribute('aria-label');
    }
    var options = results.querySelectorAll('a[role="option"],button[role="option"]');
    for (var j = 0; j < options.length; j++) {
      if (!options[j].id) {
        generatedOptionId += 1;
        options[j].id = 'dive-r13-predictive-option-' + generatedOptionId;
      }
    }
    results.setAttribute('role', 'region');
    results.setAttribute('aria-label', 'Search results');
    results.removeAttribute('aria-owns');
    var directChildren = results.children;
    for (var childIndex = 0; childIndex < directChildren.length; childIndex++) {
      directChildren[childIndex].setAttribute('role', 'presentation');
    }
    for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
      var ancestor = options[optionIndex].parentElement;
      while (ancestor && ancestor !== results) {
        ancestor.setAttribute('role', 'presentation');
        ancestor = ancestor.parentElement;
      }
    }
    var resultHeadings = results.querySelectorAll('h1,h2,h3,h4,h5,h6');
    for (var headingIndex = 0; headingIndex < resultHeadings.length; headingIndex++) {
      resultHeadings[headingIndex].setAttribute('role', 'presentation');
    }
    var primaryList = results.querySelector('#predictive-search-results-queries-list') ||
      results.querySelector('#predictive-search-results-list');
    if (primaryList && options.length) {
      var optionIds = [];
      for (var optionIdIndex = 0; optionIdIndex < options.length; optionIdIndex++) {
        optionIds.push(options[optionIdIndex].id);
      }
      primaryList.setAttribute('role', 'listbox');
      primaryList.setAttribute('aria-label', 'Search suggestions and products');
      primaryList.setAttribute('aria-owns', optionIds.join(' '));
      input.setAttribute('aria-controls', primaryList.id);
    } else {
      input.setAttribute('aria-controls', results.id);
    }
  }

  function predictivePopup(input) {
    var scope = predictiveScope(input);
    if (!scope) return null;
    return scope.querySelector('#predictive-search-results [role="listbox"]') ||
      scope.querySelector('#predictive-search-results');
  }

  function predictiveOptions(input) {
    var scope = predictiveScope(input);
    if (!scope) return [];
    normalizePredictiveListbox(input);
    var nodes = scope.querySelectorAll('#predictive-search-results [role="option"]');
    var options = [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('aria-disabled') === 'true') continue;
      if (!nodes[i].id) {
        generatedOptionId += 1;
        nodes[i].id = 'dive-r13-predictive-option-' + generatedOptionId;
      }
      options.push(nodes[i]);
    }
    return options;
  }

  function clearPredictiveSelection(input) {
    if (!input) return;
    var options = predictiveOptions(input);
    for (var i = 0; i < options.length; i++) {
      options[i].setAttribute('aria-selected', 'false');
    }
    input.removeAttribute('aria-activedescendant');
  }

  function selectPredictiveOption(input, direction) {
    var options = predictiveOptions(input);
    if (!options.length) return false;
    var activeId = input.getAttribute('aria-activedescendant') || '';
    var current = -1;
    for (var i = 0; i < options.length; i++) {
      if (options[i].id === activeId || options[i].getAttribute('aria-selected') === 'true') {
        current = i;
        break;
      }
    }
    var next;
    if (direction > 0) next = current < options.length - 1 ? current + 1 : 0;
    else next = current > 0 ? current - 1 : options.length - 1;
    for (var j = 0; j < options.length; j++) {
      options[j].setAttribute('aria-selected', j === next ? 'true' : 'false');
    }
    input.setAttribute('aria-activedescendant', options[next].id);
    try {
      options[next].scrollIntoView({ block: 'nearest' });
    } catch (e) {}
    return true;
  }

  function activatePredictiveOption(input) {
    var activeId = input.getAttribute('aria-activedescendant') || '';
    if (!activeId) return false;
    var scope = predictiveScope(input);
    var option = scope && scope.querySelector('#' + CSS.escape(activeId));
    if (!option) return false;
    var action = option.matches('a[href],button')
      ? option
      : option.querySelector('a[href],button');
    if (!action || action.disabled) return false;
    action.click();
    return true;
  }

  function bindPredictiveInputs(root) {
    var scope = root || document;
    var inputs = scope.querySelectorAll(
      'predictive-search input[role="combobox"], ' +
      'predictive-search input[type="search"][aria-expanded]'
    );
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      normalizePredictiveListbox(input);
      var popup = predictivePopup(input);
      if (popup && popup.id) input.setAttribute('aria-controls', popup.id);
      if (!input.getAttribute('aria-autocomplete')) input.setAttribute('aria-autocomplete', 'list');
      if (input.hasAttribute('data-dive-r13-predictive-bound')) continue;
      input.setAttribute('data-dive-r13-predictive-bound', 'true');
      (function (boundInput) {
        new MutationObserver(function () {
          var popup = predictivePopup(boundInput);
          if (popup && popup.id && boundInput.getAttribute('aria-controls') !== popup.id) {
            boundInput.setAttribute('aria-controls', popup.id);
          }
        }).observe(boundInput, { attributes: true, attributeFilter: ['aria-controls'] });
      })(input);
      input.addEventListener('input', function (event) {
        var scope = predictiveScope(event.currentTarget);
        var results = scope && scope.querySelector('#predictive-search-results');
        if (results) results.removeAttribute('hidden');
        clearPredictiveSelection(event.currentTarget);
      });
      input.addEventListener('keydown', function (event) {
        var target = event.currentTarget;
        var key = event.key || event.code || '';
        if (key === 'Escape' || key === 'Esc') {
          clearPredictiveSelection(target);
          return;
        }
        if (target.getAttribute('aria-expanded') !== 'true') return;
        if (key === 'ArrowDown' || key === 'Down') {
          if (!selectPredictiveOption(target, 1)) return;
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        if (key === 'ArrowUp' || key === 'Up') {
          if (!selectPredictiveOption(target, -1)) return;
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        if (key === 'Enter' && target.getAttribute('aria-activedescendant')) {
          if (!activatePredictiveOption(target)) return;
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  }

  function repairPredictiveStatuses(root) {
    var scope = root || document;
    var statuses = scope.querySelectorAll(
      '.popup-modal__search [role="status"], predictive-search [role="status"]'
    );
    for (var i = 0; i < statuses.length; i++) {
      var status = statuses[i];
      var text = cleanText(status.textContent);
      if (text.indexOf('Translation missing:') === -1) continue;
      var searchScope = status.closest('.popup-modal__search') || status.closest('predictive-search');
      var relatedInput = searchScope && searchScope.querySelector(
        'predictive-search input[role="combobox"], ' +
        'predictive-search input[type="search"][aria-expanded]'
      );
      var relatedPopup = relatedInput && predictivePopup(relatedInput);
      if (relatedInput && relatedPopup && relatedPopup.id) {
        relatedInput.setAttribute('aria-controls', relatedPopup.id);
      }
      var suggestionCount = searchScope
        ? searchScope.querySelectorAll('#predictive-search-results-queries-list [role="option"]').length
        : 0;
      var productCount = searchScope
        ? searchScope.querySelectorAll('#predictive-search-results-list [role="option"]').length
        : 0;
      if (/templates\.search\.no_results/i.test(text) || suggestionCount + productCount === 0) {
        status.textContent = 'No results.';
      } else {
        var total = suggestionCount + productCount;
        status.textContent =
          total + ' results: ' +
          plural(suggestionCount, 'suggestion', 'suggestions') + ', ' +
          plural(productCount, 'product', 'products') + '.';
      }
      status.setAttribute('data-dive-r13-predictive-status', 'repaired');
    }
  }

  function ensureMenuStyle() {
    if (document.getElementById(menuStyleId)) return;
    var style = document.createElement('style');
    style.id = menuStyleId;
    style.textContent =
      'header-desktop li[data-dive-r13-menu-trigger]:focus-within + ' +
      'li[data-dive-r13-menu-panel], ' +
      'header-desktop li[data-dive-r13-menu-trigger][data-dive-r13-menu-open="true"] + ' +
      'li[data-dive-r13-menu-panel], ' +
      'header-desktop li[data-dive-r13-menu-panel]:focus-within {' +
      'display:block !important;' +
      'visibility:visible !important;' +
      'opacity:1 !important;' +
      'pointer-events:auto !important;' +
      '}' +
      'header-desktop li[data-dive-r13-menu-trigger]:focus-within + ' +
      'li[data-dive-r13-menu-panel] > [class*="submenu-design__"], ' +
      'header-desktop li[data-dive-r13-menu-trigger][data-dive-r13-menu-open="true"] + ' +
      'li[data-dive-r13-menu-panel] > [class*="submenu-design__"], ' +
      'header-desktop li[data-dive-r13-menu-panel]:focus-within > ' +
      '[class*="submenu-design__"] {' +
      'top:0 !important;' +
      'visibility:visible !important;' +
      'opacity:1 !important;' +
      'pointer-events:auto !important;' +
      '}';
    document.head.appendChild(style);
  }

  function bindKeyboardMegamenus(root) {
    ensureMenuStyle();
    var scope = root || document;
    var triggers = scope.querySelectorAll(
      'header-desktop li.list-menu--hover.submenu-container'
    );
    for (var i = 0; i < triggers.length; i++) {
      var triggerItem = triggers[i];
      var menu = triggerItem.nextElementSibling;
      if (!menu || !menu.matches('li.submenu-container.megamenu-container')) continue;
      var trigger = triggerItem.querySelector(':scope > a[href]');
      if (!trigger) continue;
      if (!menu.id) {
        generatedMenuId += 1;
        menu.id = 'dive-r13-megamenu-' + generatedMenuId;
      }
      triggerItem.setAttribute('data-dive-r13-menu-trigger', 'true');
      menu.setAttribute('data-dive-r13-menu-panel', 'true');
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-controls', menu.id);
      if (!trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
      if (trigger.hasAttribute('data-dive-r13-menu-bound')) continue;
      trigger.setAttribute('data-dive-r13-menu-bound', 'true');

      (function (triggerElement, triggerOwner, menuElement) {
        function openMenu() {
          triggerOwner.setAttribute('data-dive-r13-menu-open', 'true');
          triggerElement.setAttribute('aria-expanded', 'true');
        }
        function closeIfOutside() {
          window.requestAnimationFrame(function () {
            if (triggerOwner.getAttribute('data-dive-r13-menu-transfer') === 'true') return;
            var active = document.activeElement;
            if (triggerOwner.contains(active) || menuElement.contains(active)) return;
            triggerOwner.removeAttribute('data-dive-r13-menu-open');
            triggerElement.setAttribute('aria-expanded', 'false');
          });
        }
        function closeOnEscape(event) {
          var key = event.key || event.code || '';
          if (key !== 'Escape' && key !== 'Esc' && event.code !== 'Escape') return;
          if (
            triggerOwner.getAttribute('data-dive-r13-menu-open') !== 'true' &&
            triggerElement.getAttribute('aria-expanded') !== 'true'
          ) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          triggerOwner.removeAttribute('data-dive-r13-menu-transfer');
          try {
            triggerElement.focus({ preventScroll: true });
          } catch (error) {
            triggerElement.focus();
          }
          /* focusin normally opens the panel, so collapse after focus moves. */
          triggerOwner.removeAttribute('data-dive-r13-menu-open');
          triggerElement.setAttribute('aria-expanded', 'false');
        }
        triggerOwner.addEventListener('focusin', openMenu);
        menuElement.addEventListener('focusin', openMenu);
        triggerOwner.addEventListener('focusout', closeIfOutside);
        menuElement.addEventListener('focusout', closeIfOutside);
        triggerOwner.addEventListener('mouseenter', openMenu);
        triggerOwner.addEventListener('mouseleave', closeIfOutside);
        menuElement.addEventListener('mouseenter', openMenu);
        menuElement.addEventListener('mouseleave', closeIfOutside);
        triggerOwner.addEventListener('keydown', closeOnEscape, true);
        menuElement.addEventListener('keydown', closeOnEscape, true);
        triggerElement.addEventListener('keydown', function (event) {
          var key = event.key || event.code || '';
          if (key !== 'ArrowDown' && key !== 'Down' && key !== 'ArrowUp' && key !== 'Up') return;
          var links = menuElement.querySelectorAll('a[href],button:not([disabled])');
          if (!links.length) return;
          event.preventDefault();
          event.stopPropagation();
          openMenu();
          var target = key === 'ArrowUp' || key === 'Up' ? links[links.length - 1] : links[0];
          try {
            target.focus({ preventScroll: true });
          } catch (e) {
            target.focus();
          }
        }, true);
      })(trigger, triggerItem, menu);
    }
  }

  function repair(root) {
    repairPending = false;
    bindPredictiveInputs(root || document);
    var predictiveInputs = document.querySelectorAll(
      'predictive-search input[role="combobox"], ' +
      'predictive-search input[type="search"][aria-expanded]'
    );
    for (var i = 0; i < predictiveInputs.length; i++) {
      normalizePredictiveListbox(predictiveInputs[i]);
    }
    repairPredictiveStatuses(root || document);
    bindKeyboardMegamenus(root || document);
  }

  window.addEventListener('keydown', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches(
      'predictive-search input[role="combobox"], ' +
      'predictive-search input[type="search"][aria-expanded]'
    )) return;
    var key = event.key || event.code || '';
    if (key === 'Escape' || key === 'Esc') {
      clearPredictiveSelection(input);
      function retainCollapsedState() {
        clearPredictiveSelection(input);
        input.setAttribute('aria-expanded', 'false');
      }
      window.setTimeout(retainCollapsedState, 0);
      window.setTimeout(retainCollapsedState, 80);
      window.setTimeout(retainCollapsedState, 220);
      return;
    }
    if (input.getAttribute('aria-expanded') !== 'true') return;
    if (key === 'ArrowDown' || key === 'Down') {
      if (!selectPredictiveOption(input, 1)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (key === 'ArrowUp' || key === 'Up') {
      if (!selectPredictiveOption(input, -1)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (key === 'Enter' && input.getAttribute('aria-activedescendant')) {
      if (!activatePredictiveOption(input)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('keydown', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var triggerOwner = target.closest('li[data-dive-r13-menu-trigger]');
    if (!triggerOwner) return;
    var trigger = triggerOwner.querySelector(':scope > a[href]');
    if (!trigger || target !== trigger) return;
    var key = event.key || event.code || '';
    if (key !== 'ArrowDown' && key !== 'Down' && key !== 'ArrowUp' && key !== 'Up') return;
    var menu = triggerOwner.nextElementSibling;
    if (!menu || !menu.matches('li[data-dive-r13-menu-panel]')) return;
    var links = menu.querySelectorAll('a[href],button:not([disabled])');
    if (!links.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    triggerOwner.setAttribute('data-dive-r13-menu-open', 'true');
    triggerOwner.setAttribute('data-dive-r13-menu-transfer', 'true');
    trigger.setAttribute('aria-expanded', 'true');
    var next = key === 'ArrowUp' || key === 'Up' ? links[links.length - 1] : links[0];
    try {
      next.focus({ preventScroll: true });
    } catch (e) {
      next.focus();
    }
    window.setTimeout(function () {
      try {
        next.focus({ preventScroll: true });
      } catch (e) {
        next.focus();
      }
      trigger.setAttribute('aria-expanded', 'true');
      triggerOwner.removeAttribute('data-dive-r13-menu-transfer');
    }, 0);
  }, true);

  function scheduleRepair() {
    if (repairPending) return;
    repairPending = true;
    window.requestAnimationFrame(function () {
      repair(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      repair(document);
    }, { once: true });
  } else {
    repair(document);
  }
  window.setTimeout(function () { repair(document); }, 400);
  window.setTimeout(function () { repair(document); }, 1400);
  window.setTimeout(function () { repair(document); }, 3700);
  new MutationObserver(scheduleRepair).observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();

/* SIGONNA-DIVE-ADA-R14-20260822 */
(function () {
  'use strict';
  if (window.__sigonnaDiveR14AccessibilityLoaded) return;
  window.__sigonnaDiveR14AccessibilityLoaded = true;

  var scheduled = false;

  function setAttributeIfChanged(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function repair() {
    scheduled = false;

    var galleries = document.querySelectorAll(
      '.swiper-thumb__container--horizontal, .swiper-thumb__container--vertical'
    );
    for (var galleryIndex = 0; galleryIndex < galleries.length; galleryIndex++) {
      var gallery = galleries[galleryIndex];
      if (!gallery.hasAttribute('tabindex')) gallery.setAttribute('tabindex', '0');
      setAttributeIfChanged(gallery, 'role', 'region');
      if (!gallery.getAttribute('aria-label')) gallery.setAttribute('aria-label', 'Product media thumbnails');
      setAttributeIfChanged(gallery, 'data-dive-r14-scroll-region', 'true');
    }

    var presentationLists = document.querySelectorAll(
      '#predictive-search-results ul[role="presentation"], ' +
      '#predictive-search-results ol[role="presentation"]'
    );
    for (var listIndex = 0; listIndex < presentationLists.length; listIndex++) {
      presentationLists[listIndex].removeAttribute('aria-labelledby');
      presentationLists[listIndex].removeAttribute('aria-label');
      presentationLists[listIndex].removeAttribute('aria-owns');
      setAttributeIfChanged(presentationLists[listIndex], 'data-dive-r14-presentational-list', 'true');
    }

    var consentHeaders = document.querySelectorAll('#shopify-pc__prefs__dialog > header');
    for (var headerIndex = 0; headerIndex < consentHeaders.length; headerIndex++) {
      setAttributeIfChanged(consentHeaders[headerIndex], 'role', 'presentation');
      consentHeaders[headerIndex].removeAttribute('aria-label');
      consentHeaders[headerIndex].removeAttribute('aria-labelledby');
      setAttributeIfChanged(consentHeaders[headerIndex], 'data-dive-r14-dialog-header', 'true');
    }

    var captcha = document.getElementById('shop-hcaptcha-badge-container');
    if (captcha) {
      setAttributeIfChanged(captcha, 'role', 'region');
      if (!captcha.getAttribute('aria-label')) captcha.setAttribute('aria-label', 'Security verification');
      setAttributeIfChanged(captcha, 'data-dive-r14-captcha-region', 'true');
    }
  }

  function scheduleRepair() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(repair);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repair, { once: true });
  } else {
    repair();
  }
  window.setTimeout(repair, 500);
  window.setTimeout(repair, 1800);
  new MutationObserver(scheduleRepair).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
